
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7Tq4R", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $a2725444c60d8295$export$2cd8252107eb640b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $9jv6U = parcelRequire("9jv6U");

var $01JF1 = parcelRequire("01JF1");

var $cGDYS = parcelRequire("cGDYS");

var $7RyUO = parcelRequire("7RyUO");

var $dunoe = parcelRequire("dunoe");

var $k2OeR = parcelRequire("k2OeR");

var $j0nzO = parcelRequire("j0nzO");

var $14zFQ = parcelRequire("14zFQ");

var $dJ4mM = parcelRequire("dJ4mM");

var $6wlNh = parcelRequire("6wlNh");

var $9uFWm = parcelRequire("9uFWm");

var $EyEcw = parcelRequire("EyEcw");

var $9Dbz6 = parcelRequire("9Dbz6");
window.BUILD_KEY = "p-91a029d5f6";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $cGDYS.default)()
    }
};
const $a2725444c60d8295$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $dunoe.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $9Dbz6.parseRoute)(window.location);
    (0, $k2OeR.isPerformanceOnetrustEnabled)() && (0, $7RyUO.initUFO)(analyticsWebClient, path);
    const parsedRequestCookies = document.cookie ? (0, $9jv6U.parse)(document.cookie) : {};
    // @ts-ignore
    const experimentOverrides = (0, $EyEcw.getExperimentOverrides)(parsedRequestCookies);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $6wlNh.edgeCachingPaths).includes(window.location.pathname)) {
        // Override for Edge Caching
        (0, $6wlNh.overrideAjsAnonIdFromCookie)();
        (0, $6wlNh.overrideAtlassianAccountIdFromCookie)();
        (0, $6wlNh.overrideCustomAttributes)();
    }
    (0, $j0nzO.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: experimentOverrides
    }).then(()=>{
        if (isStatic) {
            // @ts-ignore
            const root = (0, $01JF1.createRoot)(document.getElementById("wac"));
            root.render(/*#__PURE__*/ (0, $loA2J.jsx)((0, $9uFWm.SentryIntlProvider), {
                locale: locale,
                messages: window.SSR_languagePack,
                cookies: document.cookie,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJ4mM.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    pureClientMode: true,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    countryCode: window.countryCode,
                    agileArticle: window.agileArticle,
                    agileOverview: window.agileOverview,
                    tutorial: window.tutorial,
                    customersLanding: window.customersLanding,
                    customerStory: window.customerStory,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    isUniformPlayground: window.isUniformPlayground,
                    anchorContents: window.anchorContents,
                    persona: window.persona,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    children: Component
                })
            }));
        } else (0, $01JF1.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), /*#__PURE__*/ (0, $loA2J.jsx)((0, $9uFWm.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $14zFQ.Layout), {
                analyticsWebClient: analyticsWebClient,
                location: window.location,
                pricing: window.prices,
                availableProducts: window.availableProducts,
                agileArticle: window.agileArticle,
                agileOverview: window.agileOverview,
                tutorial: window.tutorial,
                customersLanding: window.customersLanding,
                customerStory: window.customerStory,
                templates: window.templates,
                partnerTemplates: window.partnerTemplates,
                collections: window.collections,
                categories: window.categories,
                userProfile: window.userProfile,
                userProfileStatus: window.userProfileStatus,
                userContext: window.userContext,
                userContextStatus: window.userContextStatus,
                loggedOutContext: window.loggedOutContext,
                loggedOutContextStatus: window.loggedOutContextStatus,
                countryCode: window.countryCode,
                anchorContents: window.anchorContents,
                composition: window._uniformPreloadedComposition,
                isUniformPlayground: window.isUniformPlayground,
                persona: window.persona,
                teamType: window.teamType,
                keyword: window.keyword,
                mlTemplateIds: window.mlTemplateIds,
                referrer: window.referrer,
                anchor: window.anchor,
                subAnchor: window.subAnchor,
                children: Component
            })
        }), {
            onRecoverableError: (error, errorInfo)=>{
                document.getElementById("wac-root")?.setAttribute("hydration-error", "true");
            }
        });
    });
};

});
parcelRegister("EyEcw", function(module, exports) {

$parcel$export(module.exports, "getExperimentOverrides", function () { return $a71889fc68f9e7b9$export$8022ee0ca9bf74d6; });

var $5GZK9 = parcelRequire("5GZK9");
const $a71889fc68f9e7b9$export$8022ee0ca9bf74d6 = (parsedRequestCookies)=>{
    for (const cookieKey of Object.keys(parsedRequestCookies)){
        if (cookieKey === "atlassian_exp_overrides" && parsedRequestCookies["atlassian_exp_overrides"]) return $a71889fc68f9e7b9$export$d180d40f1827eef7(parsedRequestCookies["atlassian_exp_overrides"]);
    }
    return {}; // return empty overrides if none are found
};
const $a71889fc68f9e7b9$export$d180d40f1827eef7 = (cookie)=>{
    try {
        return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($5GZK9))).decompressFromBase64(cookie));
    } catch (e) {
        return {};
    }
};

});


parcelRegister("auFti", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePage", function () { return $44fb3717bf740836$export$a6be62ed06c967ea; });

var $loA2J = parcelRequire("loA2J");

var $4LHd8 = parcelRequire("4LHd8");

var $dyZbY = parcelRequire("dyZbY");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");

var $iMdoL = parcelRequire("iMdoL");
parcelRequire("aRHrH");
var $9O2F2 = parcelRequire("9O2F2");

var $377FT = parcelRequire("377FT");
parcelRequire("6O3lV");
var $eubbX = parcelRequire("eubbX");

var $7e8IA = parcelRequire("7e8IA");
const $44fb3717bf740836$export$a6be62ed06c967ea = ()=>{
    const loggedInHasJira = (0, $iMdoL.useLoggedInHasJira)();
    const jiraD0to6 = (0, $iMdoL.useJiraD0to6)();
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom = (0, $4LHd8.default).checkGate("gwp-737-enable-intercom-chat-jsw");
    const template = jiraD0to6 ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $377FT.OrganicD1to6LoggedInJiraProductTourOverview), {}) : loggedInHasJira ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $eubbX.LoggedInJiraProductTourOverview), {}) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $7e8IA.LoggedOutOrNoJiraProductTourOverview), {});
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "jira-product-tour-overview",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9O2F2.IntercomProvider), {
            appId: "p0ww63i2",
            triggerBoot: isBootIntercom,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3LLDq.CrossFlowTouchpointProvider), {
                productKeys: [
                    (0, $i8kxh.ProductKeys).JIRA_SOFTWARE
                ],
                screenName: "wacJswProductTourPage",
                children: template
            })
        })
    });
};

});
parcelRegister("aRHrH", function(module, exports) {
$parcel$export(module.exports, "IntercomProvider", function () { return (parcelRequire("9O2F2")).IntercomProvider; });
parcelRequire("9O2F2");
parcelRequire("42XIn");

});
parcelRegister("9O2F2", function(module, exports) {

$parcel$export(module.exports, "IntercomProvider", function () { return $be094a112486886f$export$5091c5023e5c7eba; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $l4i0P = parcelRequire("l4i0P");

var $gkhN4 = parcelRequire("gkhN4");

var $7OS3I = parcelRequire("7OS3I");
const $be094a112486886f$var$isWindowExist = typeof window !== "undefined";
const $be094a112486886f$export$e578ca56db818a8e = /*#__PURE__*/ $iSvIT.createContext(undefined);
const $be094a112486886f$export$5091c5023e5c7eba = ({ appId: appId, triggerBoot: triggerBoot = false, children: children })=>{
    const isBooted = $iSvIT.useRef(false);
    const isInit = $iSvIT.useRef(false);
    const stargateClient = (0, $gkhN4.useBxpWebStargateClient)();
    const initIntercomInstance = $iSvIT.useCallback(()=>{
        if (!isInit.current) {
            (0, $7OS3I.default)(appId);
            isInit.current = true;
        }
    }, [
        appId
    ]);
    const boot = $iSvIT.useCallback(()=>{
        if ($be094a112486886f$var$isWindowExist && isInit.current && !isBooted.current) {
            const intercomSettings = window.intercomSettings ?? {
                app_id: appId
            };
            window.Intercom?.("boot", {
                alignment: "right",
                horizontal_padding: 20,
                vertical_padding: 20,
                custom_launcher_selector: "#intercomLauncher",
                ...intercomSettings
            });
            window.Intercom?.("trackEvent", "widget-loaded");
            isBooted.current = true;
        }
    }, [
        appId
    ]);
    const shutdown = $iSvIT.useCallback(()=>{
        if (!isBooted.current) return;
        if ($be094a112486886f$var$isWindowExist) {
            window.Intercom?.("shutdown");
            delete window.intercomSettings;
            isBooted.current = false;
        }
    }, []);
    const show = $iSvIT.useCallback(()=>{
        if ($be094a112486886f$var$isWindowExist && isBooted.current) window.Intercom?.("show");
    }, []);
    const hide = $iSvIT.useCallback(()=>{
        if ($be094a112486886f$var$isWindowExist && isBooted.current) window.Intercom?.("hide");
    }, []);
    $iSvIT.useEffect(()=>{
        if ($be094a112486886f$var$isWindowExist && triggerBoot) (async function() {
            const intercomSettingsObj = {
                app_id: appId
            };
            const anonId = (0, $l4i0P.default).get("ajs_anonymous_id") || "";
            if (anonId) intercomSettingsObj["anonymousId"] = anonId;
            const getwayApiMeGetResponse = await stargateClient.me({}).catch(()=>null);
            if (getwayApiMeGetResponse) {
                intercomSettingsObj["name"] = getwayApiMeGetResponse.name;
                intercomSettingsObj["email"] = getwayApiMeGetResponse.email;
            }
            if ($be094a112486886f$var$isWindowExist) window.intercomSettings = intercomSettingsObj;
            if (!isInit.current) initIntercomInstance();
            if (isInit.current && !isBooted.current) boot();
        })();
        // clean up code
        return ()=>{
            if (isInit.current) shutdown();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerBoot,
        stargateClient
    ]);
    const providerValue = $iSvIT.useMemo(()=>{
        return {
            initIntercomInstance: initIntercomInstance,
            boot: boot,
            shutdown: shutdown,
            show: show,
            hide: hide
        };
    }, [
        initIntercomInstance,
        boot,
        shutdown,
        show,
        hide
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($be094a112486886f$export$e578ca56db818a8e.Provider, {
        value: providerValue,
        children: children
    });
};
const $be094a112486886f$export$28418e623d2470bc = ()=>{
    const context = $iSvIT.useContext($be094a112486886f$export$e578ca56db818a8e);
    if (context === undefined) throw new Error("This hook must be used within IntercomProvider");
    return context;
};

});
parcelRegister("7OS3I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f03bd135604494e$export$2e2bcd8739ae039; });
function $9f03bd135604494e$var$isIELikeWindow(w) {
    return Object.prototype.hasOwnProperty.call(w, "attachEvent");
}
// Function per instruction here: https://developers.intercom.com/installing-intercom/web/installation/
const $9f03bd135604494e$var$initializeIntercomInstance = (appId)=>{
    const w = window;
    const ic = w.Intercom;
    if (typeof ic === "function") {
        ic("reattach_activator");
        ic("update", w.intercomSettings);
    } else {
        const d = document;
        const i = function() {
            i.c(arguments);
        };
        i.q = [];
        i.c = function(args) {
            i.q.push(args);
        };
        w.Intercom = i;
        const l = function() {
            const s = d.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://widget.intercom.io/widget/" + appId;
            const x = d.getElementsByTagName("script")[0];
            x?.parentNode?.insertBefore(s, x);
        };
        if (document.readyState === "complete") l();
        else if ($9f03bd135604494e$var$isIELikeWindow(w)) w.attachEvent("onload", l);
        else w.addEventListener("load", l, false);
    }
};
var $9f03bd135604494e$export$2e2bcd8739ae039 = $9f03bd135604494e$var$initializeIntercomInstance;

});


parcelRegister("42XIn", function(module, exports) {
// Intercom Types & Interface ===========================================================
// all the Interface stuff from: https://developers.intercom.com/installing-intercom/web/attributes-objects/

});


parcelRegister("377FT", function(module, exports) {

$parcel$export(module.exports, "OrganicD1to6LoggedInJiraProductTourOverview", function () { return $1edb1e7953e76466$export$e3a19954eb6bb710; });

var $loA2J = parcelRequire("loA2J");

var $kex29 = parcelRequire("kex29");

var $jq0gD = parcelRequire("jq0gD");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("ccYBS");
var $1FqEx = parcelRequire("1FqEx");

var $llbkg = parcelRequire("llbkg");

var $gjpey = parcelRequire("gjpey");

var $k8xxN = parcelRequire("k8xxN");
const $1edb1e7953e76466$export$e3a19954eb6bb710 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "jfind-organic-jpt-logged-in-redesign",
        group: "jfind-organic-jpt-logged-in-redesign",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $llbkg.JiraSitesProvider), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $jq0gD.default), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $k8xxN.default), {})
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1FqEx.ParentScrollTracking), {
                    scrollTrackingEnabled: true,
                    pageId: "jsw",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $gjpey.LoggedInHeroSection), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
                    ]
                })
            ]
        })
    });

});
parcelRegister("jq0gD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5a34c2ff8a2778c$export$2e2bcd8739ae039; });
/* sticky-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $gAJUc = parcelRequire("gAJUc");
const $c5a34c2ff8a2778c$var$StickyContainer = ({ children: children })=>{
    const isMultipleStickyStart = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).wacLiftedBannerSticky);
    if (!isMultipleStickyStart) return children;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-testid": "banner-nav-combo",
        className: (0, $esG4f.default)([
            "_kqsw1if8 _152tidpf _1pbyqfx8"
        ]),
        children: children
    });
};
const $c5a34c2ff8a2778c$var$sticky = null;
var $c5a34c2ff8a2778c$export$2e2bcd8739ae039 = $c5a34c2ff8a2778c$var$StickyContainer;

});

parcelRegister("ccYBS", function(module, exports) {
$parcel$export(module.exports, "ScrollTracking", function () { return (parcelRequire("e6FyV")).ScrollTracking; });
$parcel$export(module.exports, "useScrollTracking", function () { return (parcelRequire("e6FyV")).useScrollTracking; });
$parcel$export(module.exports, "withScrollTracking", function () { return (parcelRequire("e6FyV")).withScrollTracking; });
$parcel$export(module.exports, "ParentScrollTracking", function () { return (parcelRequire("1FqEx")).ParentScrollTracking; });
parcelRequire("e6FyV");
parcelRequire("1FqEx");

});
parcelRegister("e6FyV", function(module, exports) {

$parcel$export(module.exports, "useScrollTracking", function () { return $dd17d79dac682b5f$export$17700584f55fbc70; });
$parcel$export(module.exports, "ScrollTracking", function () { return $dd17d79dac682b5f$export$1725757b7947b890; });
$parcel$export(module.exports, "withScrollTracking", function () { return $dd17d79dac682b5f$export$391633ede08dabb1; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $iPiHn = parcelRequire("iPiHn");

var $g9kzu = parcelRequire("g9kzu");

var $1FqEx = parcelRequire("1FqEx");

var $dWbel = parcelRequire("dWbel");
const $dd17d79dac682b5f$export$17700584f55fbc70 = (section, props = {})=>{
    const { index: index, observerOptions: observerOptions } = props;
    const hasFunctionBeenCalled = (0, $iSvIT.useRef)(false);
    const scrollPercentage = (0, $iSvIT.useRef)(0);
    const { pageId: pageId, scrollTrackingEnabled: scrollTrackingEnabled } = (0, $1FqEx.useParentScrollTracking)();
    const { ref: ref, inView: inView, entry: entry } = (0, $iPiHn.useInView)({
        threshold: 0.5,
        triggerOnce: true,
        ...observerOptions,
        skip: observerOptions?.skip || !scrollTrackingEnabled
    });
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const handleScroll = ()=>{
        const windowHeight = window.innerHeight;
        const fullHeight = document.documentElement.scrollHeight;
        const currentPosition = window.scrollY;
        scrollPercentage.current = Math.round(currentPosition / (fullHeight - windowHeight) * 100);
    };
    (0, $iSvIT.useEffect)(()=>{
        if (inView && !hasFunctionBeenCalled.current && section) {
            handleScroll();
            const scrollTrackAnalyticsPayload = {
                eventType: "ui",
                action: "scrolledTo",
                actionSubject: "section",
                source: window.location.pathname,
                attributes: {
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId
                }
            };
            if (analyticsClient) {
                createAnalyticsEvent({
                    ...scrollTrackAnalyticsPayload
                }).fire();
                hasFunctionBeenCalled.current = true; // Set the state to true so the function won't be called again
            }
        }
    }, [
        analyticsClient,
        createAnalyticsEvent,
        hasFunctionBeenCalled,
        inView,
        index,
        pageId,
        section
    ]);
    return {
        ref: ref,
        inView: inView,
        entry: entry
    };
};
const $dd17d79dac682b5f$export$1725757b7947b890 = ({ section: section, index: index, observerOptions: observerOptions, children: children, as: RootElement = "div" })=>{
    const { ref: ref } = $dd17d79dac682b5f$export$17700584f55fbc70(section, {
        index: index,
        observerOptions: observerOptions
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)(RootElement, {
        ref: ref,
        children: children
    });
};
function $dd17d79dac682b5f$export$391633ede08dabb1(section, InnerComponent, options) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (props)=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)($dd17d79dac682b5f$export$1725757b7947b890, {
            section: section,
            ...options,
            children: /*#__PURE__*/ (0, $loA2J.jsx)(InnerComponent, {
                ...props
            })
        });
    };
}

});
parcelRegister("1FqEx", function(module, exports) {

$parcel$export(module.exports, "useParentScrollTracking", function () { return $5f5c2bfbd45e6855$export$164ddb76b909974a; });
$parcel$export(module.exports, "ParentScrollTracking", function () { return $5f5c2bfbd45e6855$export$248f1dfc9396e7e4; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("ccYBS");
var $e6FyV = parcelRequire("e6FyV");
const $5f5c2bfbd45e6855$var$ScrollTrackingContext = /*#__PURE__*/ (0, $iSvIT.createContext)({
    pageId: "wac-web",
    scrollTrackingEnabled: true
});
const $5f5c2bfbd45e6855$export$164ddb76b909974a = ()=>{
    return (0, $iSvIT.useContext)($5f5c2bfbd45e6855$var$ScrollTrackingContext);
};
const $5f5c2bfbd45e6855$export$248f1dfc9396e7e4 = (props)=>{
    const parentContext = $5f5c2bfbd45e6855$export$164ddb76b909974a();
    const arrayChildren = (0, $iSvIT.Children).toArray(props.children);
    const definedName = (child)=>{
        if (/*#__PURE__*/ (0, $iSvIT.isValidElement)(child) && child.type) {
            // Use a type assertion to tell TypeScript that the type has a displayName
            const namedComponent = child.type;
            return namedComponent.displayName;
        } else return undefined;
    };
    // Determine tracking of parent undefined means true
    const parentTrackScrolling = parentContext.scrollTrackingEnabled === undefined ? true : parentContext.scrollTrackingEnabled;
    // Parent should take precedence if parent tracking is disabled
    const trackScrolling = parentTrackScrolling && (props.scrollTrackingEnabled === undefined ? true : props.scrollTrackingEnabled);
    const pageId = props.pageId ?? parentContext.pageId;
    return /*#__PURE__*/ (0, $loA2J.jsx)($5f5c2bfbd45e6855$var$ScrollTrackingContext.Provider, {
        value: {
            pageId: pageId,
            scrollTrackingEnabled: trackScrolling
        },
        children: (0, $iSvIT.Children).map(arrayChildren, (child, index)=>{
            const name = definedName(child);
            return name ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $e6FyV.ScrollTracking), {
                index: `${index}/${arrayChildren.length}`,
                section: name,
                as: props.as,
                children: child
            }, index) : child;
        })
    });
};

});



parcelRegister("llbkg", function(module, exports) {

$parcel$export(module.exports, "useJiraSitesContext", function () { return $8e9cd72298660b02$export$8095836340dcdac5; });
$parcel$export(module.exports, "JiraSitesProvider", function () { return $8e9cd72298660b02$export$e5844423e4215335; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $iMdoL = parcelRequire("iMdoL");

var $lpc6z = parcelRequire("lpc6z");
const $8e9cd72298660b02$var$JiraSitesContext = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $8e9cd72298660b02$export$8095836340dcdac5 = ()=>{
    const context = (0, $iSvIT.useContext)($8e9cd72298660b02$var$JiraSitesContext);
    if (!context) throw new Error("useJiraSitesContext must be used within a JiraSitesProvider");
    return context;
};
const $8e9cd72298660b02$export$e5844423e4215335 = ({ children: children })=>{
    const [jiraSitesFromAgg, setJiraSitesFromAgg] = (0, $iSvIT.useState)(undefined);
    const { profile: profile } = (0, $iMdoL.useUserContext)();
    const aggClient = (0, $iSvIT.useMemo)(()=>new (0, $lpc6z.LoggedInUserJiraSitesClient)(), []);
    (0, $iSvIT.useEffect)(()=>{
        if (!profile.attributes?.existingSites || profile.attributes.existingSites.length !== 1) return;
        const site = profile.attributes.existingSites[0];
        aggClient.getJiraSites(site?.cloudId ?? "").then((data)=>{
            setJiraSitesFromAgg(data);
        });
    }, [
        aggClient,
        profile.attributes?.existingSites
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($8e9cd72298660b02$var$JiraSitesContext.Provider, {
        value: {
            jiraSitesFromAgg: jiraSitesFromAgg
        },
        children: children
    });
};

});

parcelRegister("gjpey", function(module, exports) {

$parcel$export(module.exports, "LoggedInHeroSection", function () { return $77a4cc16f12c1a32$export$49c6370202c57ed1; });
/* logged-in-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $dWbel = parcelRequire("dWbel");

var $kZKty = parcelRequire("kZKty");

var $g9kzu = parcelRequire("g9kzu");

var $iSjV6 = parcelRequire("iSjV6");

var $iMdoL = parcelRequire("iMdoL");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $1BHKA = parcelRequire("1BHKA");

var $dLZRK = parcelRequire("dLZRK");

var $kg4YS = parcelRequire("kg4YS");

var $5wOn9 = parcelRequire("5wOn9");

var $llbkg = parcelRequire("llbkg");
var $77a4cc16f12c1a32$var$TRACKING_EVENT_NAMES;
(function(TRACKING_EVENT_NAMES) {
    TRACKING_EVENT_NAMES["loggedInHeroProductCtaClicked"] = "loggedInHeroProductCtaClicked";
    TRACKING_EVENT_NAMES["loggedInHeroAnotherSiteCtaClicked"] = "loggedInHeroAnotherSiteCtaClicked";
    TRACKING_EVENT_NAMES["loggedInHeroExploreFeaturesClicked"] = "loggedInHeroExploreFeaturesClicked";
    TRACKING_EVENT_NAMES["loggedInHeroCreateNewSiteClicked"] = "loggedInHeroCreateNewSiteClicked";
})($77a4cc16f12c1a32$var$TRACKING_EVENT_NAMES || ($77a4cc16f12c1a32$var$TRACKING_EVENT_NAMES = {}));
const $77a4cc16f12c1a32$var$START_URL = "https://start.atlassian.com";
const $77a4cc16f12c1a32$export$cbc42fadf8b93ea3 = {
    eventType: "ui",
    action: "clicked",
    actionSubject: "button",
    actionSubjectId: "loggedInHero",
    source: "/software/jira"
};
const $77a4cc16f12c1a32$export$572cd721c4c6631c = {
    eventType: "ui",
    action: "loaded",
    actionSubject: "ATLAS-76385",
    actionSubjectId: "loggedInHero",
    source: "/software/jira",
    attributes: {
        atlasId: "ATLAS-76385"
    }
};
const $77a4cc16f12c1a32$var$jswLoggedInCss = null;
const $77a4cc16f12c1a32$var$heroSectionCss = null;
const $77a4cc16f12c1a32$var$anchorContainer = null;
const $77a4cc16f12c1a32$var$blueBackdrop = null;
const $77a4cc16f12c1a32$var$jiraSiteBoxCss = null;
const $77a4cc16f12c1a32$var$headingCss = null;
const $77a4cc16f12c1a32$var$starCss = null;
const $77a4cc16f12c1a32$var$differentSiteCss = null;
const $77a4cc16f12c1a32$var$subHeadingContainerCss = null;
const $77a4cc16f12c1a32$var$createNewSiteAnchorCss = null;
const $77a4cc16f12c1a32$var$subHeadingCss = null;
const $77a4cc16f12c1a32$var$exploreFeaturesContainerCss = null;
const $77a4cc16f12c1a32$var$exploreFeaturesHeadingCss = null;
const $77a4cc16f12c1a32$var$exploreFeaturesCtaCss = null;
const $77a4cc16f12c1a32$var$nameUnderlineCss = null;
const $77a4cc16f12c1a32$var$inlineJiraLogoCss = null;
const $77a4cc16f12c1a32$var$siteInfoContainerCss = null;
const $77a4cc16f12c1a32$var$sitenameIconCss = null;
const $77a4cc16f12c1a32$var$sitenameIconTextCss = null;
const $77a4cc16f12c1a32$var$sitenameAndAvatarContainerCss = null;
const $77a4cc16f12c1a32$var$siteNameSpanCss = null;
const $77a4cc16f12c1a32$var$tooltipWrapperCss = null;
const $77a4cc16f12c1a32$var$avatarContainerCss = null;
const $77a4cc16f12c1a32$export$49c6370202c57ed1 = ()=>{
    const loggedInUserProfile = (0, $5wOn9.useLoggedInUser)();
    const { user: user, profile: profile } = (0, $iMdoL.useUserContext)();
    const { jiraSitesFromAgg: jiraSitesFromAgg } = (0, $llbkg.useJiraSitesContext)();
    const [teammateAvatars, setTeammateAvatars] = (0, $iSvIT.useState)([]);
    // Try to get name from props, and fallback to hook if needed
    const userFirstName = user.name?.split(" ")[0] ?? loggedInUserProfile.name?.split(" ")[0];
    // Try to get picture from props, and fallback to hook if needed
    const userPicture = user?.picture ?? loggedInUserProfile.picture;
    const avatars = jiraSitesFromAgg?.jira?.allJiraProjects.edges[0]?.node.assignableUsers.edges;
    (0, $iSvIT.useEffect)(()=>{
        setTeammateAvatars(jiraSitesFromAgg?.jira?.allJiraProjects.edges[0]?.node.assignableUsers.edges.filter((assignableUser)=>assignableUser.node.picture != userPicture && assignableUser.node.accountStatus === "active").map((assignableUser)=>{
            return assignableUser.node.picture ?? "";
        }) ?? []);
    }, [
        avatars,
        jiraSitesFromAgg?.jira?.allJiraProjects.edges,
        userPicture
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const localizedTryLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&createNew=true");
    const localizedProductGuideLink = (0, $3FBn4.useLocalizedHref)("/software/jira/guides/getting-started/introduction");
    const [hasMultipleJiras, setHasMultipleJiras] = (0, $iSvIT.useState)(false);
    const [siteName, setSiteName] = (0, $iSvIT.useState)("");
    const [siteInitials, setSiteInitials] = (0, $iSvIT.useState)("");
    (0, $iSvIT.useEffect)(()=>{
        const availableJiraSites = (0, $kg4YS.filterAvailableJiraSites)(profile.attributes?.existingSites);
        // Default state to whatever we might have got from SSR
        setHasMultipleJiras(availableJiraSites.length > 1);
        const siteNameFromAvailableJiraSites = availableJiraSites[0]?.displayName || "";
        setSiteName(siteNameFromAvailableJiraSites);
        setSiteInitials(siteNameFromAvailableJiraSites.slice(0, 1).toUpperCase() + siteNameFromAvailableJiraSites.slice(1, 2));
    }, [
        profile.attributes?.existingSites
    ]);
    const [siteUrl, setSiteUrl] = (0, $iSvIT.useState)("");
    (0, $iSvIT.useEffect)(()=>{
        if (!profile && !jiraSitesFromAgg) return;
        const siteFromUserProfile = profile?.attributes?.existingSites[0];
        let projectUrl = siteFromUserProfile?.url;
        if (jiraSitesFromAgg?.jira?.allJiraProjects.edges.length === 1) projectUrl = jiraSitesFromAgg.jira.allJiraProjects?.edges[0]?.node.webUrl;
        setSiteUrl(projectUrl ?? "");
    }, [
        jiraSitesFromAgg,
        jiraSitesFromAgg?.jira?.allJiraProjects.edges,
        profile,
        profile?.attributes?.existingSites
    ]);
    (0, $iSvIT.useEffect)(()=>{
        //if client side, fire analytics event
        if (typeof window !== "undefined") createAnalyticsEvent({
            ...$77a4cc16f12c1a32$export$572cd721c4c6631c
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const clickHandler = (eventName)=>{
        createAnalyticsEvent({
            ...$77a4cc16f12c1a32$export$cbc42fadf8b93ea3,
            attributes: {
                eventName: eventName,
                url: window.location.href,
                atlasId: "ATLAS-76385"
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_kqswh2mm _11q71ybm _12vemgnk _1lrw1dfr _1e0c11p5 _yv0ehkll _4cvr1h6o _6a6z1h6o _18zr53f4 _1q5110yn _85i512am _1bsb1osq _1bhl10yn"
        ]),
        style: {
            "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_kqswh2mm _syaz1hlo _1bsb1osq _p12fk3xj _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf _s51sidpf"
            ]),
            style: {
                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswstnw _1e0c1o8l _u7co53f4 _1e02r8pp _t9ecn2ni _1mjbglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: {
                            width: 88,
                            height: 70,
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/g06k378gucflnfse7s88i0365h14j40v.webp",
                            alt: "hand-drawn stars"
                        }
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                    className: (0, $esG4f.default)([
                        "_1wybckbl _vwz48vuz _k48p9y44 _ect41pz4 _6rtho7ao _bozgidpf _so7dldb6 _19q11ylp"
                    ]),
                    style: {
                        "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                    },
                    children: userFirstName ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBackWithName",
                        defaultMessage: `Welcome back, {name}.`,
                        values: {
                            name: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                className: (0, $esG4f.default)([
                                    "_zg8l4jg8 _kqswh2mm _3p6m1sr6 _1v5vmgnk _14rnhyuj _19h91f51 _aetrb3bt _1qdggktf _1gufd439 _1czd12gs _g0nfmyb0 _18postnw _14tt14id _1ruvyjp0"
                                ]),
                                style: {
                                    "--_1f8eaoq": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.yellow400"))
                                },
                                children: userFirstName
                            })
                        }
                    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBack",
                        defaultMessage: "Welcome back"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1n261g80 _gy1p53f4 _1bah1yb4 _4cvr1q9y"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_ect4bzd7 _1wybgktf _vwz41f4h _k48p1nn1"
                            ]),
                            style: {
                                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "JiraSoftwarePageTemplate.loggedInHero.pickUpWhereYouLeftOffInProduct",
                                defaultMessage: "Pick up where you left off in <span>{product}</span>",
                                values: {
                                    product: "Jira",
                                    span: (text)=>/*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                    className: (0, $esG4f.default)([
                                                        "_1e0c1o8l _t9ec1jia _kqswh2mm _152tdlk8 _195g14id"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1BHKA.JiraMarkBrand), {})
                                                }),
                                                text
                                            ]
                                        })
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            "data-testid": "createNewSiteAnchor",
                            href: localizedTryLink,
                            onClick: ()=>clickHandler("loggedInHeroCreateNewSiteClicked"),
                            className: (0, $esG4f.default)([
                                "_ect4bzd7 _1wyb7vkz _k48pni7l _vwz41f4h _syazjk2v"
                            ]),
                            style: {
                                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                                "--_1b67llw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue700"))
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "WacSignupForm.createNewSite",
                                defaultMessage: "Create a new site"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswh2mm _16jlkb7n _1wpz1fhb"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_kqswstnw _152tx19p _rjxp1fm0 _1bsb13sl _4t3i1osq _bfhkjk2v"
                            ]),
                            style: {
                                "--_1b67llw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue700"))
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_bfhkcd5j _2rko1y44 _1bsb1osq _1ul91mjv _1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _19it1wcj _1rjc7vkz _18zr7vkz _1mougktf _kqswh2mm"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                            },
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1e0c1txw _2lx2vrvc _4cvr1h6o _4t3ivbgk _zulppxbi"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_11q7ihgv _2rko1b66 _1e0c1txw _1bah1h6o _4cvr1h6o _4t3ivbgk _1bsbvbgk _1ul9vbgk"
                                            ]),
                                            style: {
                                                "--_1efrnav": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.lime300"))
                                            },
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                                                className: (0, $esG4f.default)([
                                                    "_syaz5wis _ect41pz4 _1wyb1ejb _k48pni7l _vwz41f4h _1dyznl7k _y3gn1h6o"
                                                ]),
                                                style: {
                                                    "--_1yoj5ey": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.lime800")),
                                                    "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                                                },
                                                children: siteInitials
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                            className: (0, $esG4f.default)([
                                                "_1e0c1txw _2lx21bp4 _1bah1h6o _zulp19bv _kqswh2mm _4t3ivbgk"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                    className: (0, $esG4f.default)([
                                                        "_4t3igktf"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSjV6.default), {
                                                        content: siteName,
                                                        position: "top-end",
                                                        mousePosition: "top",
                                                        tag: "span",
                                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                            className: (0, $esG4f.default)([
                                                                "_ect4bzd7 _1wybgktf _k48p1fw0 _4t3igktf _vwz41j6v _y3gn1e5h _1bto1l2s _o5721q9c _1reo15vq _18m915vq _1e0c1o8l _s7n4jp4b _uhd0uuw1 _1tssl1r9"
                                                            ]),
                                                            style: {
                                                                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                                            },
                                                            children: siteName
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                    className: (0, $esG4f.default)([
                                                        "_4t3i1tcg _uhd0uuw1 _1tssl1r9"
                                                    ]),
                                                    children: userPicture && /*#__PURE__*/ (0, $loA2J.jsx)((0, $dLZRK.AvatarFacepile), {
                                                        max: 4,
                                                        iconSize: 24,
                                                        icons: [
                                                            userPicture,
                                                            ...teammateAvatars
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $kZKty.Adg4Button), {
                                    "data-testid": "goToJiraButton",
                                    variant: "primary",
                                    color: "yellow",
                                    href: siteUrl,
                                    size: "small",
                                    onClick: ()=>clickHandler("loggedInHeroProductCtaClicked"),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.loggedInHero.goToJira",
                                        defaultMessage: "Go to Jira"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                hasMultipleJiras && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_ect4bzd7 _1pfho7ao _1wybdlk8 _k48p1nn1 _1q511ylp _gu181h6o"
                    ]),
                    style: {
                        "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                        text: "Looking for a different site?",
                        href: $77a4cc16f12c1a32$var$START_URL,
                        type: "primary",
                        onClick: ()=>clickHandler("loggedInHeroAnotherSiteCtaClicked")
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1pfhvbgk _1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_ect4bzd7 _1wybgktf _vwz41f4h _k48p1nn1 _6rth7vkz"
                            ]),
                            style: {
                                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "JiraSoftwarePageTemplate.loggedInHero.findOutMore",
                                defaultMessage: "Want to find out more about Jira?"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            "data-testid": "exploreFeaturesAnchor",
                            href: localizedProductGuideLink,
                            onClick: ()=>clickHandler("loggedInHeroExploreFeaturesClicked"),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                className: (0, $esG4f.default)([
                                    "_ect4bzd7 _1wyb7vkz _k48pni7l _11q7glyw _r06hglyw _2rko1ul9 _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _19it1axk _80omtlke"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                },
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "jira-product-tour.staggered-double-feature-section.first-feature-link-text",
                                    defaultMessage: "Explore features"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$77a4cc16f12c1a32$export$49c6370202c57ed1.displayName = "LoggedInHeroSection";
var $77a4cc16f12c1a32$export$2e2bcd8739ae039 = $77a4cc16f12c1a32$export$49c6370202c57ed1;

});

parcelRegister("k8xxN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $557ddf3402c08680$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $iMdoL = parcelRequire("iMdoL");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $llbkg = parcelRequire("llbkg");
const $557ddf3402c08680$var$JiraLogo = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV2), {
        brand: "jira",
        type: "logo",
        appearance: "brand"
    });
const $557ddf3402c08680$var$SoftwareJiraLoggedInNavbar = ()=>{
    const intl = (0, $f6qj2.default)();
    const logoUrl = (0, $3FBn4.useLocalizedHref)("/software/jira");
    const { profile: profile } = (0, $iMdoL.useUserContext)();
    const { jiraSitesFromAgg: jiraSitesFromAgg } = (0, $llbkg.useJiraSitesContext)();
    const [siteUrl, setSiteUrl] = (0, $iSvIT.useState)("");
    (0, $iSvIT.useEffect)(()=>{
        const site = profile?.attributes?.existingSites[0];
        let tempSiteUrl = site?.url;
        if (jiraSitesFromAgg?.jira.allJiraProjects.edges.length === 1) tempSiteUrl = jiraSitesFromAgg?.jira.allJiraProjects?.edges[0]?.node?.webUrl;
        setSiteUrl(tempSiteUrl ?? "");
    }, [
        jiraSitesFromAgg?.jira.allJiraProjects.edges,
        jiraSitesFromAgg?.jira.allJiraProjects.edges.length,
        profile?.attributes?.existingSites,
        profile?.attributes?.existingSites.length
    ]);
    const goToLoggedInJira = ()=>{
        window.location.assign(siteUrl);
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
        productLogoUrl: logoUrl,
        productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($557ddf3402c08680$var$JiraLogo, {}),
        productLogoAriaLabel: intl.formatMessage({
            id: "wacJiraSoftwareNavigation.logo-label",
            defaultMessage: "Jira Software logo"
        }),
        mobileCtaText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.navbar.goToJira",
            defaultMessage: "Go to Jira"
        }),
        mobileCtaOnClick: goToLoggedInJira,
        mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($557ddf3402c08680$var$JiraLogo, {}),
        navigationTrynowCtaText: intl.formatMessage({
            id: "JiraFeatureSoftwarePageTemplate.navbar.goToJira",
            defaultMessage: "Go to Jira"
        }),
        navigationTrynowCtaOnClick: goToLoggedInJira,
        productPageNavLinks: [],
        mobileLinksSections: [],
        isShowSearchButton: false,
        isShowAppSwitcher: false,
        isShowTabletDropdown: false
    });
};
var $557ddf3402c08680$export$2e2bcd8739ae039 = $557ddf3402c08680$var$SoftwareJiraLoggedInNavbar;

});


parcelRegister("6O3lV", function(module, exports) {
$parcel$export(module.exports, "LoggedInJiraProductTourOverview", function () { return (parcelRequire("eubbX")).LoggedInJiraProductTourOverview; });
parcelRequire("eubbX");

});
parcelRegister("eubbX", function(module, exports) {

$parcel$export(module.exports, "LoggedInJiraProductTourOverview", function () { return $7408cd71bb16552a$export$5024f41464462328; });

var $loA2J = parcelRequire("loA2J");

var $kex29 = parcelRequire("kex29");

var $jq0gD = parcelRequire("jq0gD");
parcelRequire("ccYBS");
var $1FqEx = parcelRequire("1FqEx");
parcelRequire("3KlX7");
var $bPWsW = parcelRequire("bPWsW");
var $2xK1S = parcelRequire("2xK1S");
var $kg4YS = parcelRequire("kg4YS");
var $lyTo0 = parcelRequire("lyTo0");
var $3I5LE = parcelRequire("3I5LE");
var $bdunp = parcelRequire("bdunp");
var $4fxUO = parcelRequire("4fxUO");
var $hLM0W = parcelRequire("hLM0W");
var $6yfm0 = parcelRequire("6yfm0");
var $iHAem = parcelRequire("iHAem");

var $3Ketm = parcelRequire("3Ketm");
const $7408cd71bb16552a$export$5024f41464462328 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jq0gD.default), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $bPWsW.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $3Ketm.default), {})
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1FqEx.ParentScrollTracking), {
                scrollTrackingEnabled: true,
                pageId: "jsw",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $2xK1S.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $kg4YS.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $lyTo0.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $3I5LE.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $bdunp.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $4fxUO.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $hLM0W.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $6yfm0.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $iHAem.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
                ]
            })
        ]
    });
};

});
parcelRegister("3KlX7", function(module, exports) {

$parcel$export(module.exports, "JiraEnhancedAboveNavBanners", function () { return (parcelRequire("bPWsW")).default; });
$parcel$export(module.exports, "JiraPlainBanners", function () { return (parcelRequire("2xK1S")).default; });
$parcel$export(module.exports, "BlogsSection", function () { return (parcelRequire("hLM0W")).default; });
$parcel$export(module.exports, "CTASection", function () { return (parcelRequire("iHAem")).default; });
$parcel$export(module.exports, "DevOpsSection", function () { return (parcelRequire("4fxUO")).default; });
$parcel$export(module.exports, "LoggedInHeroSection", function () { return (parcelRequire("kg4YS")).default; });
$parcel$export(module.exports, "IntegrationSection", function () { return (parcelRequire("bdunp")).default; });
$parcel$export(module.exports, "ScalingSection", function () { return (parcelRequire("6yfm0")).default; });
$parcel$export(module.exports, "TabsSection", function () { return (parcelRequire("lyTo0")).default; });
$parcel$export(module.exports, "WorkflowSection", function () { return (parcelRequire("3I5LE")).default; });

var $3Ketm = parcelRequire("3Ketm");

var $bPWsW = parcelRequire("bPWsW");

var $hLM0W = parcelRequire("hLM0W");

var $iHAem = parcelRequire("iHAem");

var $4fxUO = parcelRequire("4fxUO");

var $bdunp = parcelRequire("bdunp");

var $kg4YS = parcelRequire("kg4YS");

var $2xK1S = parcelRequire("2xK1S");

var $6yfm0 = parcelRequire("6yfm0");

var $lyTo0 = parcelRequire("lyTo0");

var $3I5LE = parcelRequire("3I5LE");

});
parcelRegister("bPWsW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1bf2a34a56fa561$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $3FBn4 = parcelRequire("3FBn4");

var $47768 = parcelRequire("47768");

var $9iWJ8 = parcelRequire("9iWJ8");
const $f1bf2a34a56fa561$var$JiraEnhancedAboveNavBanners = ({ isGwp5090Test: isGwp5090Test })=>{
    const intl = (0, $f6qj2.default)();
    let template = /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {});
    const gwp5090BannerExperiment = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).gwp5090ExperimentBannerJira);
    const gwp5090IsButterBar = isGwp5090Test || gwp5090BannerExperiment && gwp5090BannerExperiment.type === "enrolled" && gwp5090BannerExperiment.value === "butterbar";
    if (gwp5090IsButterBar) {
        const gwp5090Team25Config = {
            identifier: "GWP5090.jira-product-tour.butterbar",
            text: /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "team25-banners-and-butterbars.jira-software.text",
                    defaultMessage: "<strong>April 8-10 \u2022 Anaheim, California</strong>Get a first look at the latest Jira features and AI advancements\u2014only at Team \u201925!",
                    values: (0, $3FBn4.DEFAULT_VALUES)
                })
            }),
            mobileText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "team25-banners-and-butterbars.jira-software.mobile-text",
                    defaultMessage: "<strong>April 8-10 \u2022 Anaheim, California</strong>Demo new features at Team \u201925!",
                    values: (0, $3FBn4.DEFAULT_VALUES)
                })
            }),
            productKey: "home",
            backgroundPreset: "gwp-5090-banners",
            imageProps: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4360jv8l7u81b0w6nn37fu86a2131624.webp",
                alt: "Team25",
                //Event name is not localized
                width: 200
            },
            linkText: "Get your pass",
            linkUrl: "https://events.atlassian.com/team?utm_medium=event-web-referral&utm_source=jira_product-tour&event_context=701QB00000Lg6oBYAR&utm_campaign=K:event|H:any|N:Team_25|P:agnostic|O:event-marketing|F:pre-event|C:event-home&utm_content=butterbar-banner_WEBTEAM-17396&event_id=216653",
            dataEventProps: {
                "data-product-key": "home",
                "data-event-component": "linkButton",
                "data-event-container": "announcementBanner",
                "data-event": "clicked",
                "data-label": intl.formatMessage({
                    id: "team25-banners-and-butterbars.jira-software.cta",
                    defaultMessage: "Get your pass"
                }),
                "data-label-english": "Get your pass"
            }
        };
        template = /*#__PURE__*/ (0, $loA2J.jsx)((0, $47768.EnhancedBannerAlert), {
            ...gwp5090Team25Config
        });
    }
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: template
    });
};
$f1bf2a34a56fa561$var$JiraEnhancedAboveNavBanners.displayName = "JiraEnhancedAboveNavBanners";
var $f1bf2a34a56fa561$export$2e2bcd8739ae039 = $f1bf2a34a56fa561$var$JiraEnhancedAboveNavBanners;

});
parcelRegister("47768", function(module, exports) {

$parcel$export(module.exports, "EnhancedBannerAlert", function () { return $6b681fb7f69a74b7$export$e2bb4f4abc9a31da; });
/* enhanced-banner-alert.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");

var $1syhO = parcelRequire("1syhO");
const $6b681fb7f69a74b7$export$e2bb4f4abc9a31da = (bannerInfo)=>{
    const bannerStorageItem = `BannerAlert_dismiss-${bannerInfo.identifier}`;
    const closeIconDataEventProps = {
        "data-product-key": bannerInfo.productKey,
        "data-event-component": "button",
        "data-event-container": "announcementBanner",
        "data-event": "clicked",
        "data-label": "Close",
        "data-label-english": "Close"
    };
    const [isHidden, setIsHidden] = (0, $iSvIT.useState)(true);
    const mobileClass = bannerInfo.mobileTextThirdScreen ? "three-screen" : "two-screen";
    (0, $iSvIT.useEffect)(()=>{
        const dismissValue = (0, $1syhO.getLocalStorage)(bannerStorageItem);
        if (dismissValue !== "1") setIsHidden(false);
    }, [
        bannerStorageItem
    ]);
    const bannerBgPreset = bannerInfo.backgroundPreset ? `bg-${bannerInfo.backgroundPreset}` : `bg-none`;
    const bannerType = bannerInfo.bannerType ? `banner-type-${bannerInfo.bannerType}` : "banner-type-default";
    const bgLinkColor = bannerInfo.backgroundPreset == "gwp-5090-banners" ? "bgBlackBlue" : "bgWhite";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_bfhk1ybm _kqswh2mm _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _1pbykb7n _85i5yh40 _189eh5ge _1dqonqa1 _5pio2icb _nzmgglyw _1auo1lef _21w0idpf _15641crf _s4s5idpf _1qlo1crf _7j8l1lk2 _jw2n1wug _1yvc1wug _19z9gktf _nue91vuk _1lrfidpf _pytjidpf _smywidpf _4tf1idpf _1dkqidpf _1i8zidpf _1twsidpf _c7u0idpf _1u1bjk2v _1876mq8p _gsz9mgnk _evayglyw _lhr7161t _1cmq12iu _88w1cd5j _190eni2e _wb1217a9 _vb1gvgh6 _1at2oyge _49yzdf70 _1mafcd5j _waepcd5j _ojfccd5j _1yaacd5j _6rr71ybm _fsy11ybm _1gudcd5j _1m8acd5j _1e6doxwj _hoaloxwj _cfy01ule _18901k92 _1aavidpf _72q2idpf _11sc1y44 _i4q0idpf _n8ff1cby _qho21j28 _1w7d1hlo _102q1hbo _2utfmgnk _1vm51dlf _1e74altx _1o3a1izt _1blmu4dp _1si213i1 _1k051ms4 _1yip1f51 _6zpp1f51 _eyt5xchc _nxj7u58z _7w4fcd5j",
                `${bannerBgPreset} ${bannerType}`
            ]),
            "data-dismissed": isHidden ? "true" : undefined,
            "data-testid": "banner-alert-container",
            style: {
                ...bannerInfo.customCSS,
                "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100")),
                "--_e0fbx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.purple500")),
                "--_1tgiy09": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue900")),
                "--_1b67llw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue700")),
                "--_1avknp6": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.secondary.red")),
                "--_1vwzriw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.yellow")),
                "--_b9m2cq": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.secondary.green")),
                "--_1lpv4ka": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.lime")),
                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1rjcpxbi _1e0c1txw _2lx2vrvc _zulpzwfg _kqswh2mm _6rth12gs _sugaglyw"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c1txw _4cvr1h6o"
                                        ]),
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                            image: {
                                                width: 209,
                                                ...bannerInfo.imageProps
                                            },
                                            style: {
                                                maxWidth: "100%",
                                                height: "auto"
                                            },
                                            forceEagerLoad: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_191w1xtt _4t3i1osq _sugaglyw",
                                            "line"
                                        ]),
                                        style: {
                                            "--_k3797e": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light700"))
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1bsb1osq _1e0c1txw _2lx2vrvc _1bah1yb4 _4cvr1h6o _zulpzwfg _na0i1bp4 _dh1a1y6m _2osn14y2 _ag851h6o _10ca1q9c"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                className: (0, $esG4f.default)([
                                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                    "body-md"
                                                ]),
                                                children: bannerInfo.text
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                                bgColor: bgLinkColor,
                                                text: bannerInfo.linkText,
                                                href: bannerInfo.linkUrl,
                                                type: "primary",
                                                dataEventProps: bannerInfo.dataEventProps
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1rjcpxbi _1e0cglyw _2lx21bp4 _4cvr1h6o _suga1txw"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c11p5 _p12f1osq _18zr7vkz"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow341opw _ezr91onc _17k8119v _18shrjc5 _1h6z1ule",
                                                    "_19pkidpf _2hwx1wug _otyridpf _18u01wug",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                                        image: {
                                                            width: 180,
                                                            ...bannerInfo.imageProps
                                                        },
                                                        style: {
                                                            maxWidth: "100%",
                                                            height: "auto"
                                                        },
                                                        forceEagerLoad: true
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow341opw _ezr91onc _17k8119v _18shrjc5 _1h6z1ule",
                                                    "_y3gn1h6o _1mou1wug _tzy4idpf _ju25i11n",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                    className: (0, $esG4f.default)([
                                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                        "body-md"
                                                    ]),
                                                    children: bannerInfo.mobileText
                                                })
                                            }),
                                            bannerInfo.mobileTextThirdScreen && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow341opw _ezr91onc _17k8119v _18shrjc5 _1h6z1ule",
                                                    "_y3gn1h6o _1mou1wug _tzy4idpf _ju251onc",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                    className: (0, $esG4f.default)([
                                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                        "body-md"
                                                    ]),
                                                    children: bannerInfo.mobileTextThirdScreen
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                        bgColor: bgLinkColor,
                                        text: bannerInfo.linkText,
                                        href: bannerInfo.linkUrl,
                                        type: "primary",
                                        dataEventProps: bannerInfo.dataEventProps
                                    })
                                ]
                            })
                        ]
                    })
                }),
                bannerInfo.bannerType != "lifted" && /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                    className: (0, $esG4f.default)([
                        "_19itidpf _r06hglyw _bfhk1j28 _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _1pbykb7n _rjxpidpf _19pk7vkz _2hwx7vkz _otyr7vkz _18u07vkz",
                        `close-button-symbol`
                    ]),
                    "data-testid": "close-button",
                    "aria-label": "Close",
                    onClick: ()=>{
                        setIsHidden(true);
                        (0, $1syhO.setLocalStorage)(bannerStorageItem, "1");
                    },
                    ...closeIconDataEventProps,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Cross), {
                        size: "24"
                    })
                })
            ]
        })
    });
};
const $6b681fb7f69a74b7$var$scrollUpTwoScreens = null;
const $6b681fb7f69a74b7$var$scrollUpThreeScreens = null;
const $6b681fb7f69a74b7$var$desktopContainerStyles = null;
const $6b681fb7f69a74b7$var$mobileContainerStyles = null;
const $6b681fb7f69a74b7$var$desktopLogoStyles = null;
const $6b681fb7f69a74b7$var$marqueeContainerStyles = null;
const $6b681fb7f69a74b7$var$marqueeItemStyle = null;
const $6b681fb7f69a74b7$var$marqueeItem1Styles = null;
const $6b681fb7f69a74b7$var$marqueeItem2Styles = null;
const $6b681fb7f69a74b7$var$marqueeItem3Styles = null;
const $6b681fb7f69a74b7$var$containerStyles = null;
const $6b681fb7f69a74b7$var$contentStyles = null;
const $6b681fb7f69a74b7$var$pStyle = null;
const $6b681fb7f69a74b7$var$lineStyle = null;
const $6b681fb7f69a74b7$var$closeStyles = null;

});


parcelRegister("hLM0W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a8cf0ab88e89a0d$export$2e2bcd8739ae039; });
/* blogs.tsx generated by @compiled/babel-plugin v0.28.8 */ /**
 * Add above due to attempt to merge in a merge conflict fix, which is file is out of scope for
 * Did not make a ticket to fix the nested selector on this file, due to
 * stating RW team have tickets for the whole codebase
 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");

var $bhreu = parcelRequire("bhreu");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $2a8cf0ab88e89a0d$var$blogLinkStyles = null;
const $2a8cf0ab88e89a0d$var$blogSectionStyles = null;
const $2a8cf0ab88e89a0d$var$flexWrap = null;
const $2a8cf0ab88e89a0d$var$blogLinkTextStyles = null;
const $2a8cf0ab88e89a0d$export$aa41e846a741df08 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/42xb8t784240dh2sfq3yb5k8fuq22mf1.svg",
        alt: "#1"
    });
};
const $2a8cf0ab88e89a0d$var$BlogsSection = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1yt4im2s _bfhku67f"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _yv0ei47z _1rqtf9jr _pdlmzwfg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_kzvi11p5 _1gzvzwfg _1da7f9jr"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1bsb1h3m _1yt4zu5n _1s4p1vuk _1e6zidpf _p0azv837"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)($2a8cf0ab88e89a0d$export$aa41e846a741df08, {})
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_12l2ka7h _1yt4zu5n _qwozidpf _11eb1lne _cg41l4fm _1kll1k8s _q7gq1j6v _1adi4jg8 _125xl4fm"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                                        headerType: "h2",
                                        headerText: intl.formatMessage({
                                            id: "JiraSoftwarePageTemplate.blogsSection.headerText",
                                            defaultMessage: "Why Jira is the #1 tool recommended by agile teams.*"
                                        }),
                                        bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                            id: "JiraSoftwarePageTemplate.blogsSection.bodyText",
                                            defaultMessage: "Trusted by more than 100,000 organizations, Jira comes out-of-the-box with the features and best practices agile teams need to develop and evolve their agile practices.",
                                            values: (0, $3FBn4.DEFAULT_VALUES)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_q7gq11yk _125xvwuj _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf"
                                        ]),
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                                id: "JiraSoftwarePageTemplate.blogsSection.contentFooter",
                                                defaultMessage: "*2021 State of Agile Report",
                                                values: (0, $3FBn4.DEFAULT_VALUES)
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _zulpzwfg _navj1g80 _8164idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)($2a8cf0ab88e89a0d$export$50abcf278da62381, {}),
                                    /*#__PURE__*/ (0, $loA2J.jsx)($2a8cf0ab88e89a0d$export$83dad9d4a5d7a221, {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _zulpzwfg _navj1g80 _8164idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)($2a8cf0ab88e89a0d$export$61dec29d4439a90e, {}),
                                    /*#__PURE__*/ (0, $loA2J.jsx)($2a8cf0ab88e89a0d$export$2a774c444b770d05, {})
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $2a8cf0ab88e89a0d$export$50abcf278da62381 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)($2a8cf0ab88e89a0d$var$BlogLink, {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/0r168a11o11n866jv042iaqtc2560d15.webp",
        imageAlt: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.blogsSection.agileAltText",
            defaultMessage: "Agile illustration"
        }),
        href: (0, $3FBn4.useLocalizedHref)("/agile"),
        linkText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.blogsSection.agileLinkText",
            defaultMessage: "Learn agile best practices"
        })
    });
};
const $2a8cf0ab88e89a0d$export$83dad9d4a5d7a221 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)($2a8cf0ab88e89a0d$var$BlogLink, {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/e3buc7gjy550p1825lu05t674gf7116g.webp",
        imageAlt: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.blogsSection.teamPlaybookAltText",
            defaultMessage: "Team playbook illustration"
        }),
        href: (0, $3FBn4.useLocalizedHref)("/team-playbook"),
        linkText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.blogsSection.teamPlaybookLinkText",
            defaultMessage: "Team Playbook"
        })
    });
};
const $2a8cf0ab88e89a0d$export$61dec29d4439a90e = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)($2a8cf0ab88e89a0d$var$BlogLink, {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/g5h75c61iryjfgxc47b76c644gk323uy.webp",
        imageAlt: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.blogsSection.communityAltText",
            defaultMessage: "Community illustration"
        }),
        href: "https://community.atlassian.com/",
        linkText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.blogsSection.communityLinkText",
            defaultMessage: "Jira community"
        })
    });
};
const $2a8cf0ab88e89a0d$export$2a774c444b770d05 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)($2a8cf0ab88e89a0d$var$BlogLink, {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/n2a75c42wi3oj344bot150u635h5gns3.webp",
        imageAlt: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.blogsSection.devOpsAltText",
            defaultMessage: "DevOps loop illustration"
        }),
        href: (0, $3FBn4.useLocalizedHref)("/devops"),
        linkText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.blogsSection.devOpsLinkText",
            defaultMessage: "Learn DevOps best practices"
        })
    });
};
const $2a8cf0ab88e89a0d$var$BlogLink = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_18s81cfz _1wybpxbi _1iu2u2gc"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                href: props.href,
                "data-event-component": "linkButton",
                "data-event-container": "blogsSection",
                "data-event": "clicked",
                "data-label": props.linkText,
                "data-product-key": "jiraSoftware",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
                    src: props.imageSrc,
                    alt: props.imageAlt,
                    aspectRatio: "16/9"
                })
            }),
            $2a8cf0ab88e89a0d$var$blogLinkText(props.href, props.linkText)
        ]
    });
};
const $2a8cf0ab88e89a0d$var$blogLinkText = (href, linkText)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
            href: href,
            "data-event-component": "linkButton",
            "data-event-container": "blogsSection",
            "data-event": "clicked",
            "data-label": linkText,
            "data-product-key": "jiraSoftware",
            className: (0, $esG4f.default)([
                "_ysv7rbzz _1053rbzz _5bd61r31 _1ydc1r31 _13jxglyw _1x28glyw _xatrnqa1 _1726nqa1 _30l3oelr _1mfn1gfk _nalz1b66 _1y8f1r31 _kttp8stv _14t1nqa1"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c116y _1wybpxbi",
                    "link-text"
                ]),
                children: [
                    linkText,
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: "link-arrow",
                        children: $2a8cf0ab88e89a0d$var$linkArrow()
                    })
                ]
            })
        })
    });
};
const $2a8cf0ab88e89a0d$var$linkArrow = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        fill: "currentColor",
        width: "11",
        height: "8",
        viewBox: "0 0 11 8",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $esG4f.default)([
            "_ahbq12x7"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.40796 0L6.32831 1.2021L8.07854 3.1497H0.763182C0.341906 3.1497 0 3.53038 0 3.99943C0 4.46849 0.341906 4.84917 0.763182 4.84917H8.07854L6.32831 6.7979L7.40796 8L11 3.99943L7.40796 0Z"
        })
    });
};
$2a8cf0ab88e89a0d$var$BlogsSection.displayName = "BlogsSection";
var $2a8cf0ab88e89a0d$export$2e2bcd8739ae039 = $2a8cf0ab88e89a0d$var$BlogsSection;

});
parcelRegister("ix9oc", function(module, exports) {
$parcel$export(module.exports, "ContentBlock", function () { return (parcelRequire("3hz64")).ContentBlock; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("3hz64")).ContentBlock; });

var $3hz64 = parcelRequire("3hz64");

});
parcelRegister("3hz64", function(module, exports) {

$parcel$export(module.exports, "ContentBlock", function () { return $d1a7b02864c21377$export$eb38b3b9c7f5f31b; });
/* content-block.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $8xSOc = parcelRequire("8xSOc");

var $91nJf = parcelRequire("91nJf");

var $A9zZc = parcelRequire("A9zZc");
parcelRequire("Erp3T");
var $kjssF = parcelRequire("kjssF");

var $f0Hih = parcelRequire("f0Hih");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("bQawl");
var $ca2XB = parcelRequire("ca2XB");

var $bhreu = parcelRequire("bhreu");
function $d1a7b02864c21377$var$getHeaderTag(text, header, lozenge, lozengeAppearance) {
    const headerTag = header ? header : "h3";
    const headerText = /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            text,
            lozenge && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_ahbqftgi _1e0c1o8l"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c116y _s7n4nkob"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                        appearance: lozengeAppearance,
                        children: lozenge
                    })
                })
            })
        ]
    });
    const style = lozenge ? {
        style: {
            display: "inline-block"
        }
    } : null;
    return /*#__PURE__*/ (0, $iSvIT.createElement)(headerTag, style, headerText);
}
/* Gives h tag one less than header */ function $d1a7b02864c21377$var$getEyebrowTag(headerType, eyebrowText) {
    const tagNumber = headerType ? Number(headerType.slice(-1)) : 5;
    return /*#__PURE__*/ (0, $iSvIT.createElement)(`h${tagNumber + 1}`, {
        className: "contentBlock-eyebrow"
    }, eyebrowText);
}
function $d1a7b02864c21377$var$renderLinks({ ctaProps: ctaProps, product: product, edition: edition }) {
    if (!ctaProps) return null;
    let firstLink;
    if ("buttonProps" in ctaProps && "text" in ctaProps.buttonProps) firstLink = /*#__PURE__*/ (0, $loA2J.jsx)((0, $ca2XB.Button), {
        ...ctaProps.buttonProps
    });
    else if ("buttonProps" in ctaProps && "variant" in ctaProps.buttonProps) firstLink = /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
        ...ctaProps.buttonProps
    });
    else if ("primaryLinkProps" in ctaProps && ctaProps.primaryLinkProps) firstLink = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
        ...ctaProps.primaryLinkProps
    });
    const secondaryLink = "secondaryLinkProps" in ctaProps ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
        ...ctaProps.secondaryLinkProps
    }) : null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $f0Hih.default), {
        intentType: "button",
        containerId: "ctaSection",
        edition: edition,
        productKey: product?.key,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: "contentBlock-linkFlex",
            children: [
                firstLink,
                secondaryLink
            ]
        })
    });
}
/**
 * This method retrieves either the eyebrow or icon decoration. If both are present, the icon is returned.
 * @param headerType
 */ const $d1a7b02864c21377$var$getDecoration = (headerType, eyebrowText, iconName, iconColor, iconSize)=>{
    if (iconName) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Icon), {
        name: iconName,
        color: iconColor,
        size: iconSize
    });
    else if (eyebrowText) return $d1a7b02864c21377$var$getEyebrowTag(headerType, eyebrowText);
    return null;
};
const $d1a7b02864c21377$var$getImage = (pictureProps, imageLink, imageAltText, aspectRatio)=>{
    if (pictureProps) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: "img-section",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
            ...pictureProps
        })
    });
    else if (imageLink && imageAltText) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: "img-section",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
            src: imageLink,
            alt: imageAltText,
            aspectRatio: aspectRatio
        })
    });
    else return null;
};
const $d1a7b02864c21377$var$isHtml = (text)=>{
    return text.startsWith("<") && text.endsWith(">") && text.includes("</");
};
const $d1a7b02864c21377$export$eb38b3b9c7f5f31b = ({ headerText: headerText, isBannerRichText: isBannerRichText = false, lozenge: lozenge, lozengeAppearance: lozengeAppearance = "inprogress", bodyText: bodyText, bodyComponent: bodyComponent, headerType: headerType = "h3", eyebrowText: eyebrowText, className: className = "", imageLink: imageLink, imageAltText: imageAltText, pictureProps: pictureProps, iconName: iconName, iconColor: iconColor, iconSize: iconSize, ctaProps: ctaProps, aspectRatio: aspectRatio = "1/1", orientation: orientation, cardStyle: cardStyle, isCentered: isCentered = false, horizontalRule: horizontalRule })=>{
    const { product: product, edition: edition } = (0, $kjssF.useProductIntent)();
    if (imageLink && !imageAltText) throw new Error("If using an image, please provide an alt text for accessibility purposes!");
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            isBannerRichText && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && isCentered && orientation === "horizontal" && cardStyle && headerType === "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _a5ip1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && isCentered && orientation === "horizontal" && !cardStyle && headerType === "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _a5ip1osq _1ma11kwk _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation === "horizontal" && cardStyle && headerType === "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation === "horizontal" && !cardStyle && headerType === "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && isCentered && orientation === "horizontal" && cardStyle && headerType !== "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && isCentered && orientation === "horizontal" && !cardStyle && headerType !== "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _a5ip1osq _1ma11kwk _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation === "horizontal" && cardStyle && headerType !== "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation === "horizontal" && !cardStyle && headerType !== "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && isCentered && orientation !== "horizontal" && cardStyle && headerType === "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && isCentered && orientation !== "horizontal" && !cardStyle && headerType !== "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation !== "horizontal" && cardStyle && headerType === "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation !== "horizontal" && !cardStyle && headerType === "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && isCentered && orientation !== "horizontal" && cardStyle && headerType !== "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation !== "horizontal" && cardStyle && headerType !== "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation !== "horizontal" && !cardStyle && headerType !== "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            `content-block ${className}`
        ]),
        style: {
            "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
        },
        children: [
            $d1a7b02864c21377$var$getImage(pictureProps, imageLink, imageAltText, aspectRatio),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: "text-section",
                children: [
                    headerText && $d1a7b02864c21377$var$getHeaderTag(headerText, headerType, lozenge, lozengeAppearance),
                    $d1a7b02864c21377$var$getDecoration(headerType, eyebrowText, iconName, iconColor, iconSize),
                    horizontalRule && /*#__PURE__*/ (0, $loA2J.jsx)("hr", {
                        className: (0, $esG4f.default)([
                            "_4t3iyh40 _p12f1fra"
                        ])
                    }),
                    bodyText ? typeof bodyText === "string" && $d1a7b02864c21377$var$isHtml(bodyText) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $A9zZc.SanitizedRichText), {
                        innerHTML: bodyText
                    }) : /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: "contentBlock-body",
                        children: bodyText
                    }) : null,
                    !bodyText && bodyComponent && /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: "contentBlock-body",
                        children: bodyComponent
                    }),
                    $d1a7b02864c21377$var$renderLinks({
                        ctaProps: ctaProps,
                        product: product,
                        edition: edition
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("A9zZc", function(module, exports) {

$parcel$export(module.exports, "SanitizedRichText", function () { return $d50557d96565ccec$export$efb77abbd0a81997; });
/* sanitized-rich-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $7L1zQ = parcelRequire("7L1zQ");
const $d50557d96565ccec$var$styles = null;
const $d50557d96565ccec$export$efb77abbd0a81997 = ({ innerHTML: innerHTML, tagName: Component = "span", className: className })=>{
    if (typeof innerHTML === "string") return /*#__PURE__*/ (0, $loA2J.jsx)(Component, {
        className: (0, $esG4f.default)([
            "_754n1j6v _1ci51k8s _zgxm1nn1 _171salr3 _1xsslnmy _1vapidpf _1qwqidpf _14qeidpf _18obidpf _1ps4rbzz _qs4s1r31 _iidjglyw _jopknqa1 _1dipoelr _1bw11r31 _swvz8stv _1vxgnqa1 _1uo11r31 _gugqglyw _1l07nqa1 _mvak1r31 _17u5glyw _1ldznqa1 _116xrbzz _15zsidpf _150widpf _1g0midpf _1s9iidpf _xbdr1tcg",
            `styled-text ${className ?? ""}`
        ]),
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($7L1zQ)))(innerHTML)
        }
    });
    else return null;
};

});

parcelRegister("Erp3T", function(module, exports) {
$parcel$export(module.exports, "useProductIntent", function () { return (parcelRequire("kjssF")).useProductIntent; });
parcelRequire("eeJVi");
parcelRequire("kjssF");

});
parcelRegister("eeJVi", function(module, exports) {

$parcel$export(module.exports, "ProductKey", function () { return $638022cbdd0e1e88$export$f3a53bd43617a593; });
$parcel$export(module.exports, "products", function () { return $638022cbdd0e1e88$export$b6aad051bad07f12; });
var $638022cbdd0e1e88$export$f3a53bd43617a593;
(function(ProductKey) {
    ProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    ProductKey["CONFLUENCE"] = "confluence.ondemand";
    ProductKey["JIRA_SERVICE_MANAGEMENT"] = "jira-servicedesk.ondemand";
    ProductKey["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
})($638022cbdd0e1e88$export$f3a53bd43617a593 || ($638022cbdd0e1e88$export$f3a53bd43617a593 = {}));
const $638022cbdd0e1e88$export$b6aad051bad07f12 = [
    {
        bundle: "jira-software",
        description: "Jira",
        key: "jira-software.ondemand",
        name: "jira"
    },
    {
        bundle: "confluence",
        description: "Confluence",
        key: "confluence.ondemand",
        name: "confluence"
    },
    {
        bundle: "jira-service-management",
        description: "Jira Service Management",
        key: "jira-servicedesk.ondemand",
        name: "jira-servicedesk"
    },
    {
        bundle: "jira-product-discovery",
        description: "Jira Product Discovery",
        key: "jira-product-discovery",
        name: "jira-product-discovery"
    }
];

});

parcelRegister("kjssF", function(module, exports) {

$parcel$export(module.exports, "useProductIntent", function () { return $ead1ccf5e671c3c5$export$93cccec4b411f62; });

var $iSvIT = parcelRequire("iSvIT");

var $eeJVi = parcelRequire("eeJVi");
const $ead1ccf5e671c3c5$export$93cccec4b411f62 = ()=>// eslint-disable-next-line complexity
    (0, $iSvIT.useMemo)(()=>{
        let edition;
        let product;
        if (typeof window === "undefined") return {
            edition: edition,
            product: product
        };
        const params = new URLSearchParams(window.location.search);
        if (window.location.pathname.includes("/software/jira/product-discovery")) {
            product = {
                bundle: "jira-product-discovery",
                description: "Jira Product Discovery",
                key: (0, $eeJVi.ProductKey).JIRA_PRODUCT_DISCOVERY,
                name: "jira-product-discovery"
            };
            edition = "free";
        } else if (window.location.pathname.includes("/software/jira/service-management")) {
            product = {
                bundle: "jira-service-management",
                description: "Jira Service Management",
                key: (0, $eeJVi.ProductKey).JIRA_SERVICE_MANAGEMENT,
                name: "jira-servicedesk"
            };
            edition = "free";
        } else if (window.location.pathname.includes("/software/jira")) {
            product = {
                bundle: "jira-software",
                description: "Jira",
                key: (0, $eeJVi.ProductKey).JIRA_SOFTWARE,
                name: "jira"
            };
            edition = "free";
        }
        if (window.location.pathname.includes("/software/confluence")) {
            product = {
                bundle: "confluence",
                description: "Confluence",
                key: (0, $eeJVi.ProductKey).CONFLUENCE,
                name: "confluence"
            };
            edition = "free";
        }
        const isSignupPage = window.location.pathname.endsWith("/try/cloud/signup");
        const isConfirmationPage = window.location.pathname.endsWith("/ondemand/signup/confirmation");
        if (isSignupPage || isConfirmationPage || window.IS_STORYBOOK) {
            // defaults for the signup page
            if (isSignupPage) {
                edition = "free";
                product = {
                    bundle: "jira-software",
                    description: "Jira",
                    key: (0, $eeJVi.ProductKey).JIRA_SOFTWARE,
                    name: "jira"
                };
            }
            // determine product
            if (params.has("product")) product = (0, $eeJVi.products).find((product)=>product.key === params.get("product"));
            else if (params.has("bundle")) product = (0, $eeJVi.products).find((product)=>product.bundle === params.get("bundle"));
            else if (params.has("products")) product = (0, $eeJVi.products).find((product)=>product.key === params.get("products")?.split(",")[0]);
            // determine edition
            const editionParam = params.get("edition");
            if (editionParam === "free") edition = "free";
            else if (editionParam === "standard") edition = "standard";
            else if (editionParam === "premium") edition = "premium";
        }
        return {
            edition: edition,
            product: product
        };
    }, []);

});


parcelRegister("bQawl", function(module, exports) {
$parcel$export(module.exports, "Button", function () { return (parcelRequire("ca2XB")).Button; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("ca2XB")).Button; });

var $ca2XB = parcelRequire("ca2XB");

});
parcelRegister("ca2XB", function(module, exports) {

$parcel$export(module.exports, "Button", function () { return $62ad7d149d2e5a06$export$353f5b6fc5456de1; });
/* button.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
const $62ad7d149d2e5a06$var$buttonStyles = {
    primary: {
        // default styles
        darkblue: {
            textColor: "#ffffff",
            buttonBackgroundColor: "#0052cc",
            buttonHoverColor: "#0047B3",
            buttonFocusColor: "#004099",
            border: "none"
        },
        blueprimary700: {
            textColor: "#ffffff",
            buttonBackgroundColor: "#1868DB",
            buttonHoverColor: "#0047B3",
            buttonFocusColor: "#004099",
            border: "none"
        },
        yellow: {
            textColor: "#172b4d",
            buttonBackgroundColor: "#ffab00",
            buttonHoverColor: "#ff991f",
            buttonFocusColor: "#ff8b00",
            border: "none"
        },
        green: {
            textColor: "#172b4d",
            buttonBackgroundColor: "#79f2c0",
            buttonHoverColor: "#57d9a3",
            buttonFocusColor: "#36b37e",
            border: "none"
        },
        lightblue: {
            textColor: "#0052cc",
            buttonBackgroundColor: "#deebff",
            buttonHoverColor: "#B3D4FF",
            buttonFocusColor: "#4c9aff",
            border: "none"
        },
        gray: {
            textColor: "#172b4d",
            buttonBackgroundColor: "#ebecf0",
            buttonHoverColor: "#DFE1E6",
            buttonFocusColor: "#c1c7d0",
            border: "none"
        },
        disabled: {
            textColor: "#97a0af",
            buttonBackgroundColor: "#ebecf0",
            buttonHoverColor: "",
            buttonFocusColor: "",
            border: "none"
        }
    },
    secondary: {
        darkblue: {
            textColor: "#0052cc",
            buttonBackgroundColor: "transparent",
            buttonHoverColor: "#ebecf0",
            buttonFocusColor: "#deebff",
            border: `0.063rem solid #0052cc`
        },
        blueprimary700: {
            textColor: "#1868DB",
            buttonBackgroundColor: "transparent",
            buttonHoverColor: "#ebecf0",
            buttonFocusColor: "#deebff",
            border: `0.063rem solid #1868DB`
        },
        yellow: {
            textColor: "#172b4d",
            buttonBackgroundColor: "transparent",
            buttonHoverColor: "#f4f5f7",
            buttonFocusColor: "#FFF0B3",
            border: `0.063rem solid #ffab00`
        },
        green: {
            textColor: "#172b4d",
            buttonBackgroundColor: "transparent",
            buttonHoverColor: "#f4f5f7",
            buttonFocusColor: "#e3fcef",
            border: `0.063rem solid #79f2c0`
        },
        white: {
            textColor: "#ffffff",
            buttonBackgroundColor: "transparent",
            buttonHoverColor: "rgba(255, 255, 255, 0.10)",
            buttonFocusColor: "rgba(255, 255, 255, 0.20)",
            border: `0.063rem solid #ffffff`
        },
        disabled: {
            textColor: "#97a0af",
            buttonBackgroundColor: "#ebecf0",
            buttonHoverColor: "",
            buttonFocusColor: "",
            border: "none"
        },
        whiteblue: {
            textColor: "#ffffff",
            buttonBackgroundColor: "transparent",
            buttonHoverColor: "rgba(255, 255, 255, 0.10)",
            buttonFocusColor: "rgba(255, 255, 255, 0.20)",
            border: `0.063rem solid #0052cc`
        }
    }
};
const $62ad7d149d2e5a06$var$getButtonSize = (size)=>{
    const buttonSize = size?.toLowerCase();
    if (buttonSize && buttonSize === "small") return "small";
    return "large";
};
const $62ad7d149d2e5a06$var$getButtonType = (type)=>{
    const buttonType = type?.toLowerCase();
    if (buttonType === "secondary") return "secondary";
    return "primary";
};
const $62ad7d149d2e5a06$var$isButtonColor = (color)=>{
    return color === "darkblue" || color === "blueprimary700" || color === "yellow" || color === "green" || color === "lightblue" || color === "white" || color === "gray" || color === "disabled";
};
const $62ad7d149d2e5a06$var$getButtonColor = (color, disabled)=>{
    if (disabled) return "disabled";
    const buttonColor = color?.toLowerCase();
    if (buttonColor && $62ad7d149d2e5a06$var$isButtonColor(buttonColor)) return buttonColor;
    return "darkblue";
};
const $62ad7d149d2e5a06$var$getButtonStyles = (type, color)=>{
    const styles = $62ad7d149d2e5a06$var$buttonStyles[type][color];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return styles ? styles : $62ad7d149d2e5a06$var$buttonStyles.primary.darkblue;
};
const $62ad7d149d2e5a06$export$353f5b6fc5456de1 = ({ text: text, type: type, color: color = "darkblue", size: size, onClick: onClick, url: url, externalLink: externalLink, inputType: inputType, disabled: disabled, className: className, dataEventProps: dataEventProps })=>{
    const buttonType = $62ad7d149d2e5a06$var$getButtonType(type);
    const buttonColor = $62ad7d149d2e5a06$var$getButtonColor(color, disabled);
    const { textColor: textColor, buttonBackgroundColor: buttonBackgroundColor, buttonHoverColor: buttonHoverColor, buttonFocusColor: buttonFocusColor, border: border } = $62ad7d149d2e5a06$var$getButtonStyles(buttonType, buttonColor);
    const buttonSize = $62ad7d149d2e5a06$var$getButtonSize(size);
    const fontSize = buttonSize === "large" ? "1rem" : "0.875rem";
    const height = buttonSize === "large" ? "2.5rem" : "2rem";
    const cursor = disabled ? "not-allowed" : "pointer";
    const styles = null;
    const handleOnClick = (e)=>{
        if (disabled) e.preventDefault();
        else onClick?.(e);
    };
    if ((onClick || inputType) && !url) return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1bah1h6o _11q71otn _2rko6mu8 _vchhusvi _19it145r _syaz1u00 _1e0c116y _k48pbfng _ect4lnmy _vwz41k92 _ca0qidpf _u5f31j6v _n3tdidpf _19bv1j6v _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _1du2y4cq _19lcy4cq _j6xt4hdl _1wyb25dk _4t3imry4 _80om1q22",
            className
        ]),
        onClick: handleOnClick,
        disabled: disabled,
        type: inputType,
        ...dataEventProps,
        style: {
            "--_1yb8o8o": (0, $43MIc.default)(buttonBackgroundColor),
            "--_pruigo": (0, $43MIc.default)(border),
            "--_srel9g": (0, $43MIc.default)(textColor),
            "--_1hkmuwx": (0, $43MIc.default)(buttonHoverColor),
            "--_15riry1": (0, $43MIc.default)(buttonFocusColor),
            "--_1j2e0s2": (0, $43MIc.default)(fontSize),
            "--_roksyz": (0, $43MIc.default)(height),
            "--_15yp1he": (0, $43MIc.default)(cursor)
        },
        children: text
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("a", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1bah1h6o _11q71otn _2rko6mu8 _vchhusvi _19it145r _syaz1u00 _1e0c116y _k48pbfng _ect4lnmy _vwz41k92 _ca0qidpf _u5f31j6v _n3tdidpf _19bv1j6v _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _1du2y4cq _19lcy4cq _j6xt4hdl _1wyb25dk _4t3imry4 _80om1q22",
            className
        ]),
        onClick: handleOnClick,
        href: url,
        target: externalLink ? "_blank" : undefined,
        rel: externalLink ? "noreferrer" : undefined,
        ...dataEventProps,
        style: {
            "--_1yb8o8o": (0, $43MIc.default)(buttonBackgroundColor),
            "--_pruigo": (0, $43MIc.default)(border),
            "--_srel9g": (0, $43MIc.default)(textColor),
            "--_1hkmuwx": (0, $43MIc.default)(buttonHoverColor),
            "--_15riry1": (0, $43MIc.default)(buttonFocusColor),
            "--_1j2e0s2": (0, $43MIc.default)(fontSize),
            "--_roksyz": (0, $43MIc.default)(height),
            "--_15yp1he": (0, $43MIc.default)(cursor)
        },
        children: text
    });
};

});





parcelRegister("iHAem", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11a478cdfa7761a6$export$2e2bcd8739ae039; });
/* cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");
const $11a478cdfa7761a6$var$CTASection = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/software/jira/free");
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $i8kxh.ProductKeys).JIRA_SOFTWARE,
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    const ctaButtonText = intl.formatMessage({
        id: "JiraSoftwarePageTemplate.ctaSection.getItFree",
        defaultMessage: "Get it free"
    });
    const linkDataEventProps = {
        "data-event-component": "linkButton",
        "data-event-container": "ctaSection",
        "data-event": "clicked",
        "data-product-key": "jiraSoftware",
        "data-label": ctaButtonText,
        "data-label-english": "Get it free",
        "data-track-event": "jiraSoftware.get-it-free-button-clicked"
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _bfhk1mpp _syazu67f _1e0c1txw _2lx21bp4 _zulp1tcg _ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _11ebahaf _8v2f1td8 _l5k1bfng _1kll1k8s _1nte1td8 _1qnibfng _1a7ix7w3 _ma1vi0pe _knqji0pe _sj7ki0pe _bnxci0pe _w5ku1r31 _zs4t8stv _1tjrnqa1 _1m2pmvkb"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                headerType: "h2",
                headerText: intl.formatMessage({
                    id: "JiraSoftwarePageTemplate.ctaSection.getStarted",
                    defaultMessage: "Get Started with Jira"
                }),
                orientation: "vertical",
                ctaProps: {
                    buttonProps: {
                        text: intl.formatMessage({
                            id: "JiraSoftwarePageTemplate.ctaSection.getItFree",
                            defaultMessage: "Get it free"
                        }),
                        color: "yellow",
                        url: signupLink,
                        dataEventProps: linkDataEventProps,
                        onClick: openCrossFlow
                    }
                },
                isCentered: true
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                className: "features-link",
                href: (0, $3FBn4.useLocalizedHref)("/software/jira/features"),
                text: intl.formatMessage({
                    id: "JiraSoftwarePageTemplate.ctaSection.seeFeatures",
                    defaultMessage: "See features"
                }),
                bgColor: "bgBlackBlue",
                dataEventProps: linkDataEventProps
            })
        ]
    });
};
$11a478cdfa7761a6$var$CTASection.displayName = "CTASection";
var $11a478cdfa7761a6$export$2e2bcd8739ae039 = $11a478cdfa7761a6$var$CTASection;

});

parcelRegister("4fxUO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74d77d7019dcf512$export$2e2bcd8739ae039; });
/* dev-ops.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");

var $bhreu = parcelRequire("bhreu");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $iViX8 = parcelRequire("iViX8");
const $74d77d7019dcf512$var$devOpsSectionStyle = null;
const $74d77d7019dcf512$var$DevOpsSection = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1itkfaik _ouxl1ssb _12vemgnk _1lrw1dfr _syazu67f _ca0q16xz _u5f314no _n3td16xz _19bvidpf _ai3d7vkz _fglvidpf _y5sa7vkz _1a4pidpf _1qj84jg8 _3skuahaf _1lcr1k8s _1oebvbgk _g5nwidpf _1sl9vbgk _1bkeidpf _18k6idpf _1i1pidpf _i6bg19bv _16tsidpf _1e02oqnp _3nsg4jg8 _5k96angw _vdmg1j6v _1ic74jg8 _1bl7bs82 _19p2ahaf _1o7bbfng _r6guclii _yhomp6o2 _2gm6idpf _lgxkidpf _11sridpf _1217idpf _2wcg1k92 _1ghd1nn1 _9brunl7k _11mk19ii _5c641txw _1o2r1bp4 _1von1h6o _1ufw7vkz _qaroidpf _3ogj7vkz _1r46idpf _1fwdglyw _1khm1bp4 _1vh71h6o _5cwf7vkz _uok1idpf _15x77vkz _1l1jidpf _yerozwfg _235vidpf _ugxvzwfg _1v4xidpf _1y7y7vkz _1ewg1w81 _1fes1osq _1em61bp9 _n1ju1wug _1sly1wug _exgw1wug _ow8r1wug _jss411p5 _1p0waj1j _17eu1a0z _15txzu5n _ofslglyw _1lhl1ule"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: "section-container",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: "desktop-img",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)($74d77d7019dcf512$var$DevOpsImage, {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: "content-container",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: "dev-ops-content",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                                    headerType: "h2",
                                    headerText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.devOpsSection.header",
                                        defaultMessage: "Let developers focus on code",
                                        values: (0, $3FBn4.DEFAULT_VALUES)
                                    }),
                                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.devOpsSection.body",
                                        defaultMessage: "Developers want to focus on code, not update issues. We get it! Open DevOps makes it easier to do both regardless of the tools you use. Now developers can stay focused and the business can stay aligned.",
                                        values: (0, $3FBn4.DEFAULT_VALUES)
                                    }),
                                    ctaProps: {
                                        buttonProps: {
                                            text: intl.formatMessage({
                                                id: "JiraSoftwarePageTemplate.devOpsSection.cta",
                                                defaultMessage: "Explore Open DevOps"
                                            }),
                                            url: (0, $3FBn4.useLocalizedHref)("/solutions/devops"),
                                            type: "secondary",
                                            color: "white",
                                            size: "small",
                                            dataEventProps: {
                                                "data-event-component": "linkButton",
                                                "data-event-container": "devOpsSection",
                                                "data-event": "clicked",
                                                "data-product-key": "jiraSoftware"
                                            }
                                        }
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: "mobile-img",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)($74d77d7019dcf512$var$DevOpsImage, {})
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: "benefits-container",
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                            id: "JiraSoftwarePageTemplate.devOpsSection.benefits",
                                            defaultMessage: "How customers are benefiting",
                                            values: (0, $3FBn4.DEFAULT_VALUES)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: "company-image-container",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
                                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ndd466s3h255c2d7jec4qab20voms0tf.webp",
                                            alt: intl.formatMessage({
                                                id: "JiraSoftwarePageTemplate.devOpsSection.flowLogoAlt",
                                                defaultMessage: "Flow company logo"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("h4", {
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                                id: "JiraSoftwarePageTemplate.devOpsSection.floIncreasePercent",
                                                defaultMessage: "900%",
                                                values: (0, $3FBn4.DEFAULT_VALUES)
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                                id: "JiraSoftwarePageTemplate.devOpsSection.floIncreaseMessage",
                                                defaultMessage: "<p>increase in deployments</p>",
                                                values: (0, $3FBn4.DEFAULT_VALUES)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("h4", {
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                                id: "JiraSoftwarePageTemplate.devOpsSection.floDecreasePercent",
                                                defaultMessage: "50%"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                                id: "JiraSoftwarePageTemplate.devOpsSection.floDecreaseMessage",
                                                defaultMessage: "<p>decrease in cycle time</p>",
                                                values: (0, $3FBn4.DEFAULT_VALUES)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $74d77d7019dcf512$var$DevOpsImage = ()=>{
    const intl = (0, $f6qj2.default)();
    const localizedImageSrc = (0, $iViX8.getDevOpsSectionImage)(intl.locale);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
        src: localizedImageSrc,
        alt: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.devOpsSection.imageAlt",
            defaultMessage: "Jira Software DevOps diagram: Plan, code, deploy, operate, and collaborate"
        })
    });
};
$74d77d7019dcf512$var$DevOpsSection.displayName = "DevOpsSection";
var $74d77d7019dcf512$export$2e2bcd8739ae039 = $74d77d7019dcf512$var$DevOpsSection;

});
parcelRegister("iViX8", function(module, exports) {

$parcel$export(module.exports, "getDevOpsSectionImage", function () { return $6222ffdd1f42a036$export$f5fc726b1f3a764d; });
$parcel$export(module.exports, "getPlanTabsSectionImage", function () { return $6222ffdd1f42a036$export$d0eb8e3477c372df; });
$parcel$export(module.exports, "getPlanTabsSectionVideo", function () { return $6222ffdd1f42a036$export$1185e048a42a7692; });
$parcel$export(module.exports, "getTrackTabsSectionImage", function () { return $6222ffdd1f42a036$export$3cebe896652d6248; });
$parcel$export(module.exports, "getReleaseTabsSectionImage", function () { return $6222ffdd1f42a036$export$dbda4fbdc6bac37c; });
$parcel$export(module.exports, "getReportTabsSectionImage", function () { return $6222ffdd1f42a036$export$7e0f538c5fb0ac2d; });
$parcel$export(module.exports, "getAutomateTabsSectionImage", function () { return $6222ffdd1f42a036$export$7a3d5ba0eee41c3d; });
$parcel$export(module.exports, "getWorkflowSectionImage", function () { return $6222ffdd1f42a036$export$af440fac00a2a630; });
$parcel$export(module.exports, "getScailingSectionJiraFreeImage", function () { return $6222ffdd1f42a036$export$edab907484587325; });
// no localized image for hu, it, ko, nl, pl, zh
const $6222ffdd1f42a036$var$devOpsSectionImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/v3346kr200jcjn6s25r1tt30u5v176vq.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/m6c87uds2rmr01d1l0nvt7rw1853543q.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/3gy5t516exvp226f8s16140ljfgjtt4b.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/3klwx86641ord17j6csodsaw3c8pmb4o.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/wwld70kj01143q7442d6cr0s8745ekyr.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/0fuw156nx8m1s3l553w5pbab3jb8766y.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/e6qwe41p1rm72s4qh1u7tia2sbp1jm38.webp"
};
// no localized images available for the placeholder image for the plan tab video
const $6222ffdd1f42a036$var$planTabsSectionImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/8q22ns81pbey0cqxk25j50spls50mw41.webp"
};
// no localized image for hu, it, ko, nl, pl, zh
const $6222ffdd1f42a036$var$planTabsSectionVideoMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-software/JSW-Plan.mp4",
    ja: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-software/JA/JSW-Plan-JA.mp4",
    de: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-software/DE/JSW-Plan-DE.mp4",
    es: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-software/ES/JSW-Plan-ES.mp4",
    fr: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-software/FR/JSW-Plan-FR.mp4",
    br: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-software/PT/JSW-Plan-PT-BR.mp4",
    ru: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-software/RU/JSW-Plan-RU.mp4"
};
// no localized images available
const $6222ffdd1f42a036$var$trackTabsSectionImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/5hde3vyy76yd4faeeu3mqp4yqss4500q.webp"
};
// no localized images available
const $6222ffdd1f42a036$var$releaseTabsSectionImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/e8i1y7s0mnma07f7xkvby25ju08227hx.webp"
};
// no localized images available
const $6222ffdd1f42a036$var$reportTabsSectionImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/c7w6yj6wl0skhah2wt56dv8q235782wp.webp"
};
// no localized images available
const $6222ffdd1f42a036$var$automateTabsSectionImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/4h4430vktkydp6sxq3a5ivtl85da683b.webp"
};
// no localized images available
const $6222ffdd1f42a036$var$scailingJiraFreeImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/q218xery30f2l28i55hgr8352d214y8u.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/q218xery30f2l28i55hgr8352d214y8u.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/q218xery30f2l28i55hgr8352d214y8u.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/q218xery30f2l28i55hgr8352d214y8u.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/q218xery30f2l28i55hgr8352d214y8u.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/q218xery30f2l28i55hgr8352d214y8u.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/q218xery30f2l28i55hgr8352d214y8u.webp"
};
// no localized image for hu, it, ko, nl, pl, zh
const $6222ffdd1f42a036$var$workflowSectionImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/o575pga731f3k7yeis26nm4631uc0688.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/8588gx77hlb7264626g7a25nie6083g1.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/s2rjykhu0l4cqe7i4x7ceq5i0e53eq6k.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/ti8xa750n8crthi0j41qq7md8b6m7845.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/5x4k2x175h54lv0378p6t0qoasuisby1.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/fsf33t0bun5g672x8ni1f0w713r8iem4.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/tk1o6v4elgjklv6lot8ml1m52t318304.webp"
};
const $6222ffdd1f42a036$export$f5fc726b1f3a764d = (locale)=>{
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return $6222ffdd1f42a036$var$devOpsSectionImageMap[locale] || $6222ffdd1f42a036$var$devOpsSectionImageMap["en"];
};
const $6222ffdd1f42a036$export$d0eb8e3477c372df = (locale)=>{
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return $6222ffdd1f42a036$var$planTabsSectionImageMap[locale] || $6222ffdd1f42a036$var$planTabsSectionImageMap["en"];
};
const $6222ffdd1f42a036$export$1185e048a42a7692 = (locale)=>{
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return $6222ffdd1f42a036$var$planTabsSectionVideoMap[locale] || $6222ffdd1f42a036$var$planTabsSectionVideoMap["en"];
};
const $6222ffdd1f42a036$export$3cebe896652d6248 = (locale)=>{
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return $6222ffdd1f42a036$var$trackTabsSectionImageMap[locale] || $6222ffdd1f42a036$var$trackTabsSectionImageMap["en"];
};
const $6222ffdd1f42a036$export$dbda4fbdc6bac37c = (locale)=>{
    return(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $6222ffdd1f42a036$var$releaseTabsSectionImageMap[locale] || $6222ffdd1f42a036$var$releaseTabsSectionImageMap["en"]);
};
const $6222ffdd1f42a036$export$7e0f538c5fb0ac2d = (locale)=>{
    return(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $6222ffdd1f42a036$var$reportTabsSectionImageMap[locale] || $6222ffdd1f42a036$var$reportTabsSectionImageMap["en"]);
};
const $6222ffdd1f42a036$export$7a3d5ba0eee41c3d = (locale)=>{
    return $6222ffdd1f42a036$var$automateTabsSectionImageMap[locale] || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $6222ffdd1f42a036$var$automateTabsSectionImageMap["en"];
};
const $6222ffdd1f42a036$export$af440fac00a2a630 = (locale)=>{
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return $6222ffdd1f42a036$var$workflowSectionImageMap[locale] || $6222ffdd1f42a036$var$workflowSectionImageMap["en"];
};
const $6222ffdd1f42a036$export$edab907484587325 = (locale)=>{
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return $6222ffdd1f42a036$var$scailingJiraFreeImageMap[locale] || $6222ffdd1f42a036$var$scailingJiraFreeImageMap["en"];
};

});


parcelRegister("bdunp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7293df3ef5d3f139$export$2e2bcd8739ae039; });
/* integrations.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $7293df3ef5d3f139$var$integrationStyles = null;
const $7293df3ef5d3f139$var$IntegrationSection = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _1bah1h6o _ca0qd36x _u5f3idpf _n3tdd36x _19bvidpf _bfhku67f _1mfriapn _10j01wp6 _1jg6eva1 _1j44ffox _14q21bp4 _1vlrn6wy _kgiyidpf _1w0xn6wy _958cidpf _1glwiapn _bzzi1wp6 _16tjeva1 _2h351pr0 _bpkw1bp4 _gkkofqoz _13hpzgvh _74gkeva1 _b2g01omv _i6jx16xz _1lh7idpf _z3nc16xz _wpaiidpf _1gnk1yaq _p17a1nw7 _1u5reva1 _rb2g1omv _3vsh16xz _op2cidpf _gos316xz _50abidpf _ij141yaq _1odr1h4v _18xueva1 _1o6012og _122l1yw0 _15l27vkz _vvoeidpf _jq287vkz _ckscidpf _4s0m1ssb _eupsidpf _13fo1wug _pb6midpf _p5bn1wug _1nq4ahaf _96o01j6v _x5m01tcg _f1ug1git _1gq61osq _1i2s1k8s _14o511ph _1pkrbys6 _k51wvehm _x22w1bqd _htr7dlk8 _1sm8bfng _1oki1mpp _mrde1tcg _11cj4jg8 _1bmsbys6 _rtzsvehm _17o5idpf _19zhidpf _1wroidpf _1a6aidpf _wqjv1y44 _1lrs19bv _8sqc1y44 _1i4a19bv _11y6bfng _1hlgn7od _1ykebys6 _7ihwvehm"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: "integrations-content",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                    headerText: intl.formatMessage({
                        id: "JiraSoftwarePageTemplate.integrationSection.header",
                        defaultMessage: "We believe in open relationships"
                    }),
                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "JiraSoftwarePageTemplate.integrationSection.body",
                        defaultMessage: "If your team uses it, we integrate with it. Easily add your tools from the Atlassian Marketplace, keeping Jira as your central source of truth.",
                        values: (0, $3FBn4.DEFAULT_VALUES)
                    }),
                    headerType: "h2",
                    isCentered: true,
                    orientation: "vertical",
                    ctaProps: {
                        buttonProps: {
                            text: intl.formatMessage({
                                id: "JiraSoftwarePageTemplate.integrationSection.cta",
                                defaultMessage: "Explore integrations"
                            }),
                            url: "https://marketplace.atlassian.com/",
                            type: "secondary",
                            size: "small",
                            dataEventProps: {
                                "data-event-component": "linkButton",
                                "data-event-container": "integrationSection",
                                "data-event": "clicked",
                                "data-product-key": "jiraSoftware"
                            }
                        }
                    }
                })
            })
        })
    });
};
$7293df3ef5d3f139$var$IntegrationSection.displayName = "IntegrationSection";
var $7293df3ef5d3f139$export$2e2bcd8739ae039 = $7293df3ef5d3f139$var$IntegrationSection;

});

parcelRegister("2xK1S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d759fbc306cac48c$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("fovuc");
var $5ZfUA = parcelRequire("5ZfUA");

var $3FBn4 = parcelRequire("3FBn4");

var $9iWJ8 = parcelRequire("9iWJ8");
const $d759fbc306cac48c$var$JiraPlainBanners = ({ isGwp5090Test: isGwp5090Test })=>{
    const intl = (0, $f6qj2.default)();
    const aiBannerMessages = {
        identifier: "jira-software.banner-alert.atlassian-intelligence",
        text: intl.formatMessage({
            id: "jira-software.banner-alert.text",
            defaultMessage: "Transform teamwork with Atlassian Intelligence - now available."
        }),
        linkText: intl.formatMessage({
            id: "jira-software.banner-alert.link-text",
            defaultMessage: "Learn more"
        }),
        linkUrl: (0, $3FBn4.useLocalizedHref)("/software/artificial-intelligence"),
        dataEventProps: {
            "data-product-key": "jiraSoftware",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Learn more",
            "data-label-english": "Learn more"
        }
    };
    let template = /*#__PURE__*/ (0, $loA2J.jsx)((0, $5ZfUA.BannerAlert), {
        ...aiBannerMessages
    });
    const gwp5090BannerExperiment = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).gwp5090ExperimentBannerJira);
    const gwp5090IsButterBar = isGwp5090Test || gwp5090BannerExperiment && gwp5090BannerExperiment.type === "enrolled" && gwp5090BannerExperiment.value === "butterbar";
    if (gwp5090IsButterBar) template = /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {});
    return template;
};
$d759fbc306cac48c$var$JiraPlainBanners.displayName = "JiraPlainBanners";
var $d759fbc306cac48c$export$2e2bcd8739ae039 = $d759fbc306cac48c$var$JiraPlainBanners;

});
parcelRegister("fovuc", function(module, exports) {
$parcel$export(module.exports, "BannerAlert", function () { return (parcelRequire("5ZfUA")).BannerAlert; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("5ZfUA")).BannerAlert; });

var $5ZfUA = parcelRequire("5ZfUA");

});
parcelRegister("5ZfUA", function(module, exports) {

$parcel$export(module.exports, "BannerAlert", function () { return $a7a242474da496d8$export$4eb8f3e4e539379b; });
/* banner-alert.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");

var $1syhO = parcelRequire("1syhO");
const $a7a242474da496d8$var$containerStyles = null;
const $a7a242474da496d8$var$contentStyles = null;
const $a7a242474da496d8$var$closeIconStyles = null;
const $a7a242474da496d8$export$4eb8f3e4e539379b = ({ identifier: identifier, text: text, linkText: linkText, linkUrl: linkUrl, dataEventProps: dataEventProps, hasProductNavBar: hasProductNavBar })=>{
    const intl = (0, $f6qj2.default)();
    const bannerStorageItem = `BannerAlert_dismiss-${identifier}`;
    const translatedLabel = intl.formatMessage({
        id: "banner-alert.close.aria-label",
        defaultMessage: "Close"
    });
    const [isHidden, setIsHidden] = (0, $iSvIT.useState)(true);
    (0, $iSvIT.useEffect)(()=>{
        let dismissValue = null;
        dismissValue = (0, $1syhO.getLocalStorage)(bannerStorageItem);
        if (dismissValue !== "1") setIsHidden(false);
    }, [
        bannerStorageItem
    ]);
    const dynamicStyles = hasProductNavBar ? {
        marginBlockStart: "60px"
    } : {};
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "banner-alert",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            "data-dismissed": isHidden ? "true" : undefined,
            className: (0, $esG4f.default)([
                "_bfhkuzct _kqswh2mm _y4ti1ejb _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _1pbykb7n _nzmgglyw"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                    "aria-label": translatedLabel,
                    onClick: ()=>{
                        setIsHidden(true);
                        (0, $1syhO.setLocalStorage)(bannerStorageItem, "1");
                    },
                    className: (0, $esG4f.default)([
                        "_r06hglyw _bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _rjxp1ul9 _152tpxbi _1nj119tk"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Cross), {
                        size: "20"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    style: dynamicStyles,
                    className: (0, $esG4f.default)([
                        "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _bozgxy5q _y4tixncg _1e0c11p5 _syaz1mpp _1a9ox7w3 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1 _1d61glyw _14l354rc"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                children: text
                            }),
                            "\xa0",
                            linkText && linkUrl && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                text: linkText,
                                href: linkUrl,
                                type: "inline",
                                dataEventProps: dataEventProps
                            })
                        ]
                    })
                })
            ]
        })
    });
};

});



parcelRegister("6yfm0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c0b3e3947a09581$export$2e2bcd8739ae039; });
/* scaling.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");

var $bhreu = parcelRequire("bhreu");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $iViX8 = parcelRequire("iViX8");
const $4c0b3e3947a09581$var$backgroundStyles = null;
const $4c0b3e3947a09581$var$ScalingSection = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_bfhk1mpp _12vemgnk _syazu67f _ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _59381r31 _yha28stv _1nmznqa1 _gkko1pdx _13hp1ssb _b2g01dfr _1gnkx3m7 _p17a1m79 _rb2g1s9t _ij14x3m7 _1odr1c44 _1o601i26"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_kzvi1txw _1gzvzwfg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _1bsbzufs _p12fjsxk _11ebahaf _l5k14jg8 _17z41g1n _jw8h1tcg _q7gq1j6v _zcqxbs82 _1hr2uxkd _1rfm1osq _1kll1k8s"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                            headerType: "h2",
                            headerText: intl.formatMessage({
                                id: "JiraSoftwarePageTemplate.scalingSection.headerText",
                                defaultMessage: "Built for teams of 1 to 35,000"
                            }),
                            bodyText: intl.formatMessage({
                                id: "JiraSoftwarePageTemplate.scalingSection.bodyText",
                                defaultMessage: "A growing team doesn\u2019t need to mean growing pains. With best-of-breed features, security, privacy, and the right tool for every step of your journey - Jira allows you to scale without friction - regardless of your company size."
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0cglyw _1itkcsvi _ouxlfo30 _12vemgnk _1lrwgi01 _1mjb1txw"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _2lx21bp4 _zulpor1b _ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)($4c0b3e3947a09581$var$ScalingStepsForSmallScreen, {
                                    imageSrc: (0, $iViX8.getScailingSectionJiraFreeImage)(intl.locale),
                                    imageAltText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.scalingSection.small.jiraFree",
                                        defaultMessage: "Jira free"
                                    }),
                                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.scalingSection.small.jiraSoftwareFree",
                                        defaultMessage: "Jira free forever for teams up to 10",
                                        values: (0, $3FBn4.DEFAULT_VALUES)
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)($4c0b3e3947a09581$var$ScalingStepsForSmallScreen, {
                                    imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/j35w660pt742q2m6rnk083y2610rnw71.webp",
                                    imageAltText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.scalingSection.small.jiraSoftware",
                                        defaultMessage: "Jira Software"
                                    }),
                                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.scalingSection.small.jiraSoftwareStandard",
                                        defaultMessage: "Jira Standard for growing teams",
                                        values: (0, $3FBn4.DEFAULT_VALUES)
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)($4c0b3e3947a09581$var$ScalingStepsForSmallScreen, {
                                    imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/55gl86x3tg73mwa05i2qifsd51400818.webp",
                                    imageAltText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.scalingSection.small.jiraSoftwarePremium",
                                        defaultMessage: "Jira Premium"
                                    }),
                                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.scalingSection.small.jiraSoftwarePremiumScale",
                                        defaultMessage: "Scale across teams with <a>Jira Premium</a>",
                                        values: {
                                            a: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                                    // eslint-disable-next-line react-hooks/rules-of-hooks
                                                    href: (0, $3FBn4.useLocalizedHref)("/software/jira/premium"),
                                                    "data-event-component": "linkButton",
                                                    "data-event-container": "textBlock",
                                                    "data-event": "clicked",
                                                    "data-label": "Jira Premium",
                                                    "data-product-key": "jiraSoftware",
                                                    children: str
                                                }),
                                            ...(0, $3FBn4.DEFAULT_VALUES)
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)($4c0b3e3947a09581$var$ScalingStepsForSmallScreen, {
                                    imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/6p36547re745xu475rp6214nr53vj3q0.webp",
                                    imageAltText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.scalingSection.small.jiraSoftwareEnterprise",
                                        defaultMessage: "Jira Enterprise"
                                    }),
                                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.scalingSection.small.jiraSoftwareEnterpriseConnect",
                                        defaultMessage: "Connect and accelerate your entire <a>enterprise</a>",
                                        values: {
                                            a: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                                    // eslint-disable-next-line react-hooks/rules-of-hooks
                                                    href: (0, $3FBn4.useLocalizedHref)("/software/jira/enterprise"),
                                                    "data-event-component": "linkButton",
                                                    "data-event-container": "textBlock",
                                                    "data-event": "clicked",
                                                    "data-label": "enterprise",
                                                    "data-product-key": "jiraSoftware",
                                                    children: str
                                                }),
                                            ...(0, $3FBn4.DEFAULT_VALUES)
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)($4c0b3e3947a09581$var$ScalingStepsForSmallScreen, {
                                    imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/s0f7hv6783r3srwgwj2ko2e1rk8808at.webp",
                                    imageAltText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.scalingSection.small.jiraAlign",
                                        defaultMessage: "Jira Align"
                                    }),
                                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.scalingSection.small.jiraAlignEnterprise",
                                        defaultMessage: "Enterprise agility with Jira Align",
                                        values: (0, $3FBn4.DEFAULT_VALUES)
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _1pfh1cg9 _6rthgktf _1mjbglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _1bah1h6o _1itk5eq5 _ouxl44ox _12vemgnk _1lrw1vx1 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _kqswh2mm _1e021ssb _t9eczr6s _1bsb6aaz _p12f1757"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)($4c0b3e3947a09581$var$ScalingStepsForLargeScreen, {
                                    imageSrc: (0, $iViX8.getScailingSectionJiraFreeImage)(intl.locale),
                                    imageAltText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.scalingSection.large.jiraFree",
                                        defaultMessage: "Jira free"
                                    }),
                                    cssTop: "80px",
                                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.scalingSection.large.jiraSoftwareFree",
                                        defaultMessage: "Jira free forever for teams up to 10",
                                        values: (0, $3FBn4.DEFAULT_VALUES)
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)($4c0b3e3947a09581$var$ScalingStepsForLargeScreen, {
                                    imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/j35w660pt742q2m6rnk083y2610rnw71.webp",
                                    imageAltText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.scalingSection.large.jiraSoftware",
                                        defaultMessage: "Jira"
                                    }),
                                    cssTop: "60px",
                                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.scalingSection.large.jiraSoftwareStandard",
                                        defaultMessage: "Jira Standard for growing teams",
                                        values: (0, $3FBn4.DEFAULT_VALUES)
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)($4c0b3e3947a09581$var$ScalingStepsForLargeScreen, {
                                    imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/55gl86x3tg73mwa05i2qifsd51400818.webp",
                                    imageAltText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.scalingSection.large.jiraSoftwarePremium",
                                        defaultMessage: "Jira Premium"
                                    }),
                                    cssTop: "40px",
                                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.scalingSection.large.jiraSoftwarePremiumScale",
                                        defaultMessage: "Scale across teams with <a>Jira Premium</a>",
                                        values: {
                                            a: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                                    // eslint-disable-next-line react-hooks/rules-of-hooks
                                                    href: (0, $3FBn4.useLocalizedHref)("/software/jira/premium"),
                                                    "data-event-component": "linkButton",
                                                    "data-event-container": "textBlock",
                                                    "data-event": "clicked",
                                                    "data-label": "Jira Premium",
                                                    "data-product-key": "jiraSoftware",
                                                    children: str
                                                }),
                                            ...(0, $3FBn4.DEFAULT_VALUES)
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)($4c0b3e3947a09581$var$ScalingStepsForLargeScreen, {
                                    imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/6p36547re745xu475rp6214nr53vj3q0.webp",
                                    imageAltText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.scalingSection.large.jiraSoftwareEnterprise",
                                        defaultMessage: "Jira Enterprise"
                                    }),
                                    cssTop: "20px",
                                    // disabling eslint because the bodyText prop is a ReactNode
                                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.scalingSection.large.jiraSoftwareEnterpriseConnect",
                                        defaultMessage: "Connect and accelerate your entire <a>enterprise</a>",
                                        values: {
                                            a: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                                    // eslint-disable-next-line react-hooks/rules-of-hooks
                                                    href: (0, $3FBn4.useLocalizedHref)("/software/jira/enterprise"),
                                                    "data-event-component": "linkButton",
                                                    "data-event-container": "textBlock",
                                                    "data-event": "clicked",
                                                    "data-label": "enterprise",
                                                    "data-product-key": "jiraSoftware",
                                                    children: str
                                                }),
                                            ...(0, $3FBn4.DEFAULT_VALUES)
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)($4c0b3e3947a09581$var$ScalingStepsForLargeScreen, {
                                    imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/s0f7hv6783r3srwgwj2ko2e1rk8808at.webp",
                                    imageAltText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.scalingSection.large.jiraAlign",
                                        defaultMessage: "Jira Align"
                                    }),
                                    cssTop: "0",
                                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.scalingSection.large.jiraAlignEnterprise",
                                        defaultMessage: "Enterprise agility with Jira Align",
                                        values: (0, $3FBn4.DEFAULT_VALUES)
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $4c0b3e3947a09581$var$ScalingStepsForSmallScreen = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _4cvr1h6o _bna753f4 _1rg253f4 _mezj53f4 _1lx8cs5v"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
                    src: props.imageSrc,
                    alt: props.imageAltText
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_4cvr1h6o _1e0c1txw _bozgzwfg _1bsb1ssb _1s4p1wug"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: (0, $esG4f.default)([
                        "_1wyb1j6v _19pkidpf _2hwxidpf _otyridpf _18u0idpf _vwz4bs82"
                    ]),
                    children: props.bodyText
                })
            })
        ]
    });
};
const $4c0b3e3947a09581$var$ScalingStepsForLargeScreen = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1bsbauyy"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1bah1h6o _1tke1wdt _kqswh2mm _1iu27vkz _f45rh2mm _12xta1to _mezj53f4 _bna753f4 _1lx8cs5v _aetrb3bt _18postnw _1qdgmgvx _19nq14em _eq431r3d _19h91cud _1v5vlllb _8s22gvcq _1bqqkb7n"
                    ]),
                    style: {
                        "--_1wfsy9y": (0, $43MIc.default)(props.cssTop)
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
                        src: props.imageSrc,
                        alt: props.imageAltText
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_bfhkdu3w _2rko1ssb _4t3igktf _19pkidpf _2hwx1wug _otyr1ul9 _18u01wug _1bsbgktf"
                    ])
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_1wyb1j6v _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o _vwz4bs82"
                        ]),
                        children: props.bodyText
                    })
                })
            ]
        })
    });
};
$4c0b3e3947a09581$var$ScalingSection.displayName = "ScalingSection";
var $4c0b3e3947a09581$export$2e2bcd8739ae039 = $4c0b3e3947a09581$var$ScalingSection;

});

parcelRegister("lyTo0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9b7ea371335eca8$export$2e2bcd8739ae039; });
/* tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $3FBn4 = parcelRequire("3FBn4");
parcelRequire("6dRh5");
var $dq9mP = parcelRequire("dq9mP");

var $iViX8 = parcelRequire("iViX8");
const $e9b7ea371335eca8$var$TabsSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const QUOTE_IMAGE_PROPS = {
        className: "tab-quote-image",
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/41knb7g4sf3cg6sj54o2uubv0r3r3n33.svg",
        alt: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.tabs.quoteAlt",
            defaultMessage: "Quotation mark"
        })
    };
    const planLocalizedImageSrc = (0, $iViX8.getPlanTabsSectionImage)(intl.locale);
    const planLocalizedVideoSrc = (0, $iViX8.getPlanTabsSectionVideo)(intl.locale);
    const trackLocalizedImageSrc = (0, $iViX8.getTrackTabsSectionImage)(intl.locale);
    const releaseLocalizedImageSrc = (0, $iViX8.getReleaseTabsSectionImage)(intl.locale);
    const reportLocalizedImageSrc = (0, $iViX8.getReportTabsSectionImage)(intl.locale);
    const automateLocalizedImageSrc = (0, $iViX8.getAutomateTabsSectionImage)(intl.locale);
    const getPlanLocalizedMedia = (locale)=>{
        // english should show a still image, other locales will show a localized gif (since the still has not been localized)
        if (locale === "en") return {
            imageProps: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8q22ns81pbey0cqxk25j50spls50mw41.webp",
                alt: intl.formatMessage({
                    id: "JiraSoftwarePageTemplate.tabsPlan.imageAltText",
                    defaultMessage: "" // TODO - still awaiting what this should be
                }),
                aspectRatio: "none"
            }
        };
        return {
            videoProps: {
                videoLink: planLocalizedVideoSrc,
                videoPreviewImage: planLocalizedImageSrc,
                aspectRatio: "none"
            }
        };
    };
    const planLocalizedMedia = getPlanLocalizedMedia(intl.locale);
    const tabs = [
        {
            textLabel: "Plan",
            id: "tab-plan",
            headerText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsHeader.plan",
                defaultMessage: "Plan"
            }),
            bodyText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsBody.plan",
                defaultMessage: "Break the big ideas down into manageable chunks across teams with user stories, issues, and tasks."
            }),
            quoteImageProps: QUOTE_IMAGE_PROPS,
            quote: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsQuote.plan",
                defaultMessage: "Work becomes a lot more visible when it's all in one place. It makes collaboration a whole lot easier."
            }),
            name: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsName.plan",
                defaultMessage: "Jeff Lai"
            }),
            company: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwarePageTemplate.tabsCompany.plan",
                defaultMessage: "Internal Infrastructure, canva",
                values: (0, $3FBn4.DEFAULT_VALUES)
            }),
            display: planLocalizedMedia
        },
        {
            textLabel: "Track",
            id: "tab-track",
            headerText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsHeader.track",
                defaultMessage: "Track"
            }),
            bodyText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsBody.track",
                defaultMessage: "Prioritize and discuss your team\u2019s work in context with complete visibility at every level."
            }),
            quoteImageProps: QUOTE_IMAGE_PROPS,
            quote: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsQuote.track",
                defaultMessage: "The pace of delivery from idea to reality has exploded."
            }),
            name: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsName.track",
                defaultMessage: "Greg Franklin"
            }),
            company: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwarePageTemplate.tabsCompany.track",
                defaultMessage: "Agile lead, Cancer Research UK",
                values: (0, $3FBn4.DEFAULT_VALUES)
            }),
            display: {
                imageProps: {
                    src: trackLocalizedImageSrc,
                    alt: intl.formatMessage({
                        id: "JiraSoftwarePageTemplate.tabsImageAltText.track",
                        defaultMessage: "The timeline view in Jira allows users to review progress by sprints in weeks, months, or quarters. Status is by category in this example."
                    })
                }
            }
        },
        {
            textLabel: "Release",
            id: "tab-release",
            headerText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsHeader.release",
                defaultMessage: "Release"
            }),
            bodyText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsBody.release",
                defaultMessage: "Ship faster, with confidence knowing the information you have is always up-to-date."
            }),
            quoteImageProps: QUOTE_IMAGE_PROPS,
            quote: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsQuote.release",
                defaultMessage: "Less friction in the development process means better results and a faster time to market."
            }),
            name: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsName.release",
                defaultMessage: "Louis Bennett"
            }),
            company: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwarePageTemplate.tabsCompany.release",
                defaultMessage: "Director of Engineering, Trulia",
                values: (0, $3FBn4.DEFAULT_VALUES)
            }),
            display: {
                imageProps: {
                    src: releaseLocalizedImageSrc,
                    alt: intl.formatMessage({
                        id: "JiraSoftwarePageTemplate.tabsImageAltText.release",
                        defaultMessage: "Releases within a Jira project. This view contains the version, status, progress, start date, release date, and description."
                    })
                }
            }
        },
        {
            textLabel: "Report",
            id: "tab-report",
            headerText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsHeader.report",
                defaultMessage: "Report"
            }),
            bodyText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsBody.report",
                defaultMessage: "Improve team performance in context, based on real-time, visual data."
            }),
            quoteImageProps: QUOTE_IMAGE_PROPS,
            quote: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsQuote.report",
                defaultMessage: "Full visibility in Jira across the whole organization enables you to make better management judgment. "
            }),
            name: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsName.report",
                defaultMessage: "Paul Leaon"
            }),
            company: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwarePageTemplate.tabsCompany.report",
                defaultMessage: "Digital Portfolio Director, Inchcape",
                values: (0, $3FBn4.DEFAULT_VALUES)
            }),
            display: {
                imageProps: {
                    src: reportLocalizedImageSrc,
                    alt: intl.formatMessage({
                        id: "JiraSoftwarePageTemplate.tabsImageAltText.report",
                        defaultMessage: "Within the Kanban board in Jira, a project backlog shows 5 issues are on the board and 8 are in backlog."
                    })
                }
            }
        },
        {
            textLabel: "Automate",
            id: "tab-automate",
            headerText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsHeader.automate",
                defaultMessage: "Automate"
            }),
            bodyText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsBody.automate",
                defaultMessage: "Save time, keep your team focused, and help work flow with no-code automation."
            }),
            quoteImageProps: QUOTE_IMAGE_PROPS,
            quote: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsQuote.automate",
                defaultMessage: "We\u2019re saving 150 hours+ of valuable engineering time per month. "
            }),
            name: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsName.automate",
                defaultMessage: "Jeff Lai"
            }),
            company: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwarePageTemplate.tabsCompany.automate",
                defaultMessage: "Internal Infrastructure, canva",
                values: (0, $3FBn4.DEFAULT_VALUES)
            }),
            display: {
                imageProps: {
                    src: automateLocalizedImageSrc,
                    alt: intl.formatMessage({
                        id: "JiraSoftwarePageTemplate.tabsImageAltText.automate",
                        defaultMessage: "Automation workflow in Jira. An example automation closes all stories in an epic when the epic is completed."
                    })
                }
            }
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1dyznl7k _30peazy9 _6k4u1ssb _8vi8mgnk _1ls11dfr _1n8kokh7 _1so11y44 _5ilw7vkz _9oja1y44 _yf2h7vkz _14lo1ehm _1hkv1r31 _ntb519ly _spxy1o36 _hycx1k92 _1ijg1j28 _c2wd14gx _d7qx1osq _kzzg1wug _t4tn1wug _sfzq1wug _rsoa1wug _xkf4glyw _5e4v1j6v _zglv1ylp _10h7idpf _9enho7ao _10k7idpf _g2i4o7ao _1glu1osq _16gd1r31 _1ifu19ly _15ln1o36 _1flj66rk _w7gs7vkz _o1ftidpf _vryy7vkz _rtmhidpf _1lz31y6m _mumd1mrw _1j2u1h6o _1b6rbfng _wg8cnl7k _16y31td8 _vussahaf _i80qidpf _1y3uidpf _vq3zidpf _1x7sidpf _suv51td8 _uyj9ahaf _gem2idpf _1gtzidpf _19s1idpf _p2anidpf _10tn1tcg _v3z0lnmy _10vf1tcg _p1061k92 _7iyz4jg8 _zqtwnl7k _130319ii _ebc91k8s _18gv1k8s _1wkh1msg _1nq1glyw _bh331k92 _1s0mcjiy _tq29oxwj _1bap10nf _9izn12it _14sx1l9c _1kz6cs5v _19mv12it _q7gq1k92 _zcqxcjiy"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dq9mP.TabsQuote), {
            id: "tabs-section",
            label: "Tabs",
            headerText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsHeader",
                defaultMessage: "All from a single source of truth"
            }),
            bodyText: "",
            tabs: tabs,
            colors: {
                defaultBG: "#42526e",
                defaultText: "#dfe1e6",
                activeBG: "#57d9a3",
                activeText: "#091e42",
                hoverBG: "#42526e",
                hoverText: "#dfe1e6",
                quoteColor: "#0065ff"
            },
            className: "software-jira-tabs"
        })
    });
};
$e9b7ea371335eca8$var$TabsSection.displayName = "TabsSection";
var $e9b7ea371335eca8$export$2e2bcd8739ae039 = $e9b7ea371335eca8$var$TabsSection;

});
parcelRegister("6dRh5", function(module, exports) {
$parcel$export(module.exports, "TabsQuote", function () { return (parcelRequire("dq9mP")).TabsQuote; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("dq9mP")).TabsQuote; });

var $dq9mP = parcelRequire("dq9mP");

});
parcelRegister("dq9mP", function(module, exports) {

$parcel$export(module.exports, "TabsQuote", function () { return $c80b07db157526ca$export$ad1b9d9a70aaa9a5; });
/* tabs-quote.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");

var $gXzhc = parcelRequire("gXzhc");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");
const $c80b07db157526ca$var$StatsStyle = null;
const $c80b07db157526ca$var$TabsWrapper = null;
const $c80b07db157526ca$export$ad1b9d9a70aaa9a5 = ({ id: id, label: label, headerText: headerText, bodyText: bodyText, tabs: tabs, colors: colors, ctaProps: ctaProps, linkPosition: linkPosition = "bottom", className: className, tabContentType: tabContentType = "quoteTextImage" })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_syazu67f _ca0qvbgk _u5f3idpf _n3tdvbgk _19bvidpf _i6jxckbl _1lh7idpf _z3ncckbl _wpaiidpf _1kmxzwfg _1ggmidpf _1ykzzwfg _1maeidpf",
            className
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                layout: "10",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                    className: "tabs-quote-header-content-block",
                    headerText: headerText,
                    headerType: "h2",
                    bodyText: bodyText,
                    isCentered: true,
                    ctaProps: linkPosition == "top" && ctaProps?.primaryLinkProps ? ctaProps : {}
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_ca0qgktf _u5f3idpf _n3tdgktf _19bvidpf",
                    "tabquote-tab-group-div"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gXzhc.TabGroup), {
                    colors: colors,
                    tabContentType: tabContentType,
                    tabs: tabs,
                    id: id,
                    label: label
                })
            }),
            linkPosition == "bottom" && ctaProps?.primaryLinkProps ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                        ...ctaProps.primaryLinkProps
                    })
                })
            }) : null
        ]
    });
};

});



parcelRegister("3I5LE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2930c69fe87b86f$export$2e2bcd8739ae039; });
/* workflow.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $bhreu = parcelRequire("bhreu");

var $gXzhc = parcelRequire("gXzhc");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $iViX8 = parcelRequire("iViX8");
const $a2930c69fe87b86f$var$sectionStyles = null;
const $a2930c69fe87b86f$var$h3Styles = null;
const $a2930c69fe87b86f$export$ccd9b7bceade3f2e = ()=>{
    const intl = (0, $f6qj2.default)();
    const localizedImageSrc = (0, $iViX8.getWorkflowSectionImage)(intl.locale);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
        src: localizedImageSrc,
        alt: "Diagram showcasing an example workflow using Jira Software"
    });
};
const $a2930c69fe87b86f$var$WorkflowSection = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _syazu67f _1e0c1txw _2lx21bp4 _1itkq02d _12vemgnk _1ywg1g6a _17m61ssb _16nzmgnk _9r801dfr _fehp1txw _4fwavrvc _1j0qkb7n _lei9kb7n _16arf1ug _10hl37uc _1uazkb7n _sjxrf1ug _f5z61w8u _cx5866rk _bh331k92 _1s0mcjiy _tq29oxwj _1bap10nf _9izn12it _14sx1l9c _1kz6cs5v _19mv12it _1dne1h6o _1g7k1txw _bclw1txw _lqde1h6o _1qws1bp4 _ig1uzwfg _14zoxy5q _16qj9by0 _fa5hidpf _11ku1txw _ty5v1h6o _12451bp4 _1bgrxy5q _maztzwfg _151u9by0"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_y3gn1h6o _k48p4jg8 _1wybahaf _1lzoviql _1cqs1k8s _q5ugidpf _7tldidpf _14adidpf _4uroidpf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "JiraSoftwarePageTemplate.workflowSection.header",
                    defaultMessage: "Easier than ever",
                    values: (0, $3FBn4.DEFAULT_VALUES)
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: "workflow-body",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: "icon-gradient",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)($a2930c69fe87b86f$var$IconGradient, {})
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: "workflow-container",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    className: "workflow-center-left",
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                            className: (0, $esG4f.default)([
                                                "_y3gn1h6o _18s8olf4 _k48p4jg8 _1s181k8s _1cqs15x9"
                                            ]),
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                                id: "JiraSoftwarePageTemplate.workflowSection.templatesHeader",
                                                defaultMessage: "Templates give you a head start",
                                                values: (0, $3FBn4.DEFAULT_VALUES)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                            className: "workflow-paragraph",
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                                id: "JiraSoftwarePageTemplate.workflowSection.templatesSubheader",
                                                defaultMessage: "Get started with ready-made templates.",
                                                values: (0, $3FBn4.DEFAULT_VALUES)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                            className: "template-items-container",
                                            children: [
                                                /*#__PURE__*/ (0, $loA2J.jsx)($a2930c69fe87b86f$export$e9ddabec9e160c60, {}),
                                                /*#__PURE__*/ (0, $loA2J.jsx)($a2930c69fe87b86f$export$663afa91d60a5406, {}),
                                                /*#__PURE__*/ (0, $loA2J.jsx)($a2930c69fe87b86f$export$37aa17f472de4267, {}),
                                                /*#__PURE__*/ (0, $loA2J.jsx)($a2930c69fe87b86f$export$4c29df8ef83059b3, {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_2rko1msg _ahbq16gx"
                                            ]),
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gXzhc.Quote), {
                                                image: /*#__PURE__*/ (0, $loA2J.jsx)($a2930c69fe87b86f$export$8b64c1894b7932a5, {}),
                                                quote: intl.formatMessage({
                                                    id: "JiraSoftwarePageTemplate.workflowSection.quote",
                                                    defaultMessage: "You can decide how you are working as a team first and then let the software work around you."
                                                }) + '"',
                                                name: intl.formatMessage({
                                                    id: "JiraSoftwarePageTemplate.workflowSection.name",
                                                    defaultMessage: "Maria Bonorchis"
                                                }),
                                                company: intl.formatMessage({
                                                    id: "JiraSoftwarePageTemplate.workflowSection.company",
                                                    defaultMessage: "Agile Delivery Manager, Cancer Research UK"
                                                }),
                                                colors: {
                                                    defaultBG: "#42526e",
                                                    defaultText: "#dfe1e6",
                                                    activeBG: "#57d9a3",
                                                    activeText: "#091e42",
                                                    hoverBG: "#172b4d",
                                                    hoverText: "#dfe1e6",
                                                    quoteColor: "#0065ff"
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    className: "workflow-center-right",
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                            className: (0, $esG4f.default)([
                                                "_y3gn1h6o _18s8olf4 _k48p4jg8 _1s181k8s _1cqs15x9"
                                            ]),
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                                id: "JiraSoftwarePageTemplate.workflowSection.customizeHeader",
                                                defaultMessage: "Then customize as you grow",
                                                values: (0, $3FBn4.DEFAULT_VALUES)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                            className: "workflow-paragraph",
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                                id: "JiraSoftwarePageTemplate.workflowSection.customizeSubheader",
                                                defaultMessage: "Jira adapts to the way you work, not the other way around. Start simple, customize as you go.",
                                                values: (0, $3FBn4.DEFAULT_VALUES)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)($a2930c69fe87b86f$export$ccd9b7bceade3f2e, {})
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $a2930c69fe87b86f$export$8b64c1894b7932a5 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
        className: "quote-image",
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/41knb7g4sf3cg6sj54o2uubv0r3r3n33.svg",
        alt: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.workflowSection.quoteImage",
            defaultMessage: "Quotation mark"
        })
    });
};
const $a2930c69fe87b86f$var$iconGradientStyles = null;
const $a2930c69fe87b86f$export$e9ddabec9e160c60 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)($a2930c69fe87b86f$var$TemplateItem, {
        headerText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.workflowSection.scrum",
            defaultMessage: "Scrum"
        }),
        image: "https://dam-cdn.atl.orangelogic.com/AssetLink/643n66r557l1i8psu0j0x23qpm6iwou8.svg",
        imageAltText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.workflowSection.scrumImageAltText",
            defaultMessage: "Agile illustration"
        }),
        href: (0, $3FBn4.useLocalizedHref)("/software/jira/templates/scrum")
    });
};
const $a2930c69fe87b86f$export$663afa91d60a5406 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)($a2930c69fe87b86f$var$TemplateItem, {
        headerText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.workflowSection.kanban",
            defaultMessage: "Kanban"
        }),
        image: "https://dam-cdn.atl.orangelogic.com/AssetLink/0det02q2xy1le35o8c17l73a4l2i5cc3.svg",
        imageAltText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.workflowSection.kanbanImageAltText",
            defaultMessage: "Kanban illustration"
        }),
        href: (0, $3FBn4.useLocalizedHref)("/software/jira/templates/kanban")
    });
};
const $a2930c69fe87b86f$export$37aa17f472de4267 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)($a2930c69fe87b86f$var$TemplateItem, {
        headerText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.workflowSection.bugTracking",
            defaultMessage: "Bug tracking"
        }),
        image: "https://dam-cdn.atl.orangelogic.com/AssetLink/qom8s2168ye5a741003k5m28v8r80g57.svg",
        imageAltText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.workflowSection.bugTrackingImageAltText",
            defaultMessage: "Bug illustration"
        }),
        href: (0, $3FBn4.useLocalizedHref)("/software/jira/templates/bug-tracking")
    });
};
const $a2930c69fe87b86f$export$4c29df8ef83059b3 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)($a2930c69fe87b86f$var$TemplateItem, {
        headerText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.workflowSection.devops",
            defaultMessage: "DevOps"
        }),
        image: "https://dam-cdn.atl.orangelogic.com/AssetLink/a3sp26uogt07ms5yk75s00e817f0bc84.svg",
        imageAltText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.workflowSection.devopsImageAltText",
            defaultMessage: "Devops illustration"
        }),
        href: (0, $3FBn4.useLocalizedHref)("/software/jira/templates/devops")
    });
};
const $a2930c69fe87b86f$export$4abdf9d2812569c8 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
        className: "workflow-icon",
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5vtd6c8c862vqv281l8rhxtq1hk4s273.svg",
        alt: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.workflowSection.templatesIcon",
            defaultMessage: "Templates icon"
        })
    });
};
const $a2930c69fe87b86f$export$e168ed240d9b8ab4 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
        className: "workflow-icon",
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ukex56bd8hjxoa63505tiq5s671s7qgc.svg",
        alt: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.workflowSection.workflowIcon",
            defaultMessage: "Workflow icon"
        })
    });
};
const $a2930c69fe87b86f$var$IconGradient = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1yb4 _p12fbxu3 _ouxl1ssb _12vemgnk _1gde1bp4 _1ywgi5dd _9r80vpnh _1u2q1x1l _xlt11x1l _476d1ssb _tnru1elo _1lp7vrvc _7uciw5cs _1l1414tn _1wfq176h _15vt176h _1ywmka7h _1lvaka7h _14b51n8h _qst38vuz"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)($a2930c69fe87b86f$export$4abdf9d2812569c8, {}),
            /*#__PURE__*/ (0, $loA2J.jsx)($a2930c69fe87b86f$export$e168ed240d9b8ab4, {})
        ]
    });
};
const $a2930c69fe87b86f$var$templateStyles = null;
const $a2930c69fe87b86f$var$TemplateItem = ({ headerText: headerText, image: image, imageAltText: imageAltText, href: href })=>{
    const intl = (0, $f6qj2.default)();
    const dataEventProps = {
        "data-event-component": "linkButton",
        "data-event-container": "workflowSection",
        "data-event": "clicked",
        "data-product-key": "jiraSoftware"
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1mgfv2br _a9cgmbak _18s81jx0 _1bsb1osq _1dfeu2gc _l0khu2gc _jaedbfng _h1451k92 _qyzc1td8 _1reg1h6o _ornn1bqd _1c4j1txw _1dr3xncg _jsbh1h6o _1ebypxbi _18lj146b _1qmmmbak _1c1i1fhb _1twsalr3 _1d591txw _uuuv1bp4 _1nfs1h6o _juhrpxbi _c8ehu2gc _1vcgpxbi _1hec1osq _1oqcidpf _1i6fidpf _x83zdlk8 _416xidpf _znp2i0pe _13fei0pe _rh7zi0pe _1oiii0pe _b2flx7w3 _hvglx7w3 _fza7x7w3 _1urxx7w3 _jds6i0pe _l3b8i0pe _54zzi0pe _15zui0pe _12591r31 _10e48stv _3zu2nqa1 _17ccmvkb"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: "template-image-container",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
                    src: image,
                    alt: imageAltText
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: "template-link-container",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: "template-header",
                        children: headerText
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                        text: intl.formatMessage({
                            id: "JiraSoftwarePageTemplate.workflowSection.learnMore",
                            defaultMessage: "Learn more"
                        }),
                        href: href,
                        bgColor: "bgBlackBlue",
                        dataEventProps: dataEventProps
                    })
                ]
            })
        ]
    });
};
$a2930c69fe87b86f$var$WorkflowSection.displayName = "WorkflowSection";
var $a2930c69fe87b86f$export$2e2bcd8739ae039 = $a2930c69fe87b86f$var$WorkflowSection;

});





parcelRegister("bfGvY", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $831212f3b8a942df$var$hasElementType = typeof Element !== "undefined";
var $831212f3b8a942df$var$hasMap = typeof Map === "function";
var $831212f3b8a942df$var$hasSet = typeof Set === "function";
var $831212f3b8a942df$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $831212f3b8a942df$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$831212f3b8a942df$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($831212f3b8a942df$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$831212f3b8a942df$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($831212f3b8a942df$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($831212f3b8a942df$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($831212f3b8a942df$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$831212f3b8a942df$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $831212f3b8a942df$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("lzzak", function(module, exports) {

$parcel$export(module.exports, "useUID", function () { return $fb482505c2962b4d$export$87d05f07e65211f1; });
$parcel$export(module.exports, "useUIDSeed", function () { return $fb482505c2962b4d$export$bb5ca5fba6fb4f1f; });

var $iSvIT = parcelRequire("iSvIT");

var $2mGe8 = parcelRequire("2mGe8");
var $fb482505c2962b4d$var$generateUID = function(context) {
    var quartz = context || (0, $2mGe8.counter);
    var prefix = (0, $2mGe8.getPrefix)(quartz);
    var id = (0, $2mGe8.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $fb482505c2962b4d$var$useUIDState = function() {
    var context = (0, $iSvIT.useContext)((0, $2mGe8.source));
    var uid = (0, $iSvIT.useState)(function() {
        return $fb482505c2962b4d$var$generateUID(context);
    })[0];
    return uid;
};
var $fb482505c2962b4d$export$87d05f07e65211f1 = function() {
    var uid = $fb482505c2962b4d$var$useUIDState().uid;
    return uid;
};
var $fb482505c2962b4d$export$bb5ca5fba6fb4f1f = function() {
    var gen = $fb482505c2962b4d$var$useUIDState().gen;
    return gen;
};

});
parcelRegister("2mGe8", function(module, exports) {

$parcel$export(module.exports, "counter", function () { return $1b8e643ba833cfcb$export$e575061ef2a070eb; });
$parcel$export(module.exports, "source", function () { return $1b8e643ba833cfcb$export$b4d5da5f34fb77ad; });
$parcel$export(module.exports, "getId", function () { return $1b8e643ba833cfcb$export$218c8c3169c024d2; });
$parcel$export(module.exports, "getPrefix", function () { return $1b8e643ba833cfcb$export$36e24695f02d4503; });

var $iSvIT = parcelRequire("iSvIT");

var $cFJ5y = parcelRequire("cFJ5y");
var $1b8e643ba833cfcb$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = "";
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $cFJ5y.generateUID)()
    };
};
var $1b8e643ba833cfcb$export$e575061ef2a070eb = $1b8e643ba833cfcb$export$1921362e86c73c88();
var $1b8e643ba833cfcb$export$b4d5da5f34fb77ad = $iSvIT.createContext($1b8e643ba833cfcb$export$1921362e86c73c88());
var $1b8e643ba833cfcb$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $1b8e643ba833cfcb$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : "";
};

});


parcelRegister("fxdfZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2b48c91a1934e1c$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $1xv8a = parcelRequire("1xv8a");
class $b2b48c91a1934e1c$export$2e2bcd8739ae039 extends (0, $iSvIT.Component) {
    constructor(props){
        super(props);
        /** In the event that we only want to show a fallback for a specific error,
   * we can pass a function to shouldShowFallback that will determine if the fallback should be shown
   * Returns true if shouldShowFallback is not provided or if the function returns true
   **/ this.shouldRenderFallback = ()=>{
            if (!this.state.error) return false;
            if (!this.props.shouldShowFallback) return true;
            return this.props.shouldShowFallback(this.state.error);
        };
        this.state = {};
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            error: error
        };
    }
    componentDidCatch(error, info) {
        // Call onError callback if provided
        this.props.onError?.(error, info);
        // Log the error
        (0, $1xv8a.Helpers).sendWrapperLoadError(error.message, info.componentStack ?? undefined);
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        if (this.shouldRenderFallback()) return fallback;
        return children;
    }
}

});

parcelRegister("bZcXh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b9f70d243a7264d$export$2e2bcd8739ae039; });
function $8b9f70d243a7264d$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("cQk7Y", function(module, exports) {

$parcel$export(module.exports, "ALGOLIA_APP_ID", function () { return $bfeeaa29e3f9a245$export$17b978e8ab9e4c58; });
$parcel$export(module.exports, "ALGOLIA_SEARCH_API_KEY", function () { return $bfeeaa29e3f9a245$export$ac6f6796ae1ab0c1; });
$parcel$export(module.exports, "ALGOLIA_FACET_KEY", function () { return $bfeeaa29e3f9a245$export$b23c3af39ccf497d; });
$parcel$export(module.exports, "activeSearchIndex", function () { return $bfeeaa29e3f9a245$export$e9dac33bbaf86e02; });
$parcel$export(module.exports, "activeSearchIndexV3", function () { return $bfeeaa29e3f9a245$export$b337d69b7a65e111; });
$parcel$export(module.exports, "AA_AUTOCOMPLETE_POTENTIAL_CONVERSION_EVENT_LOCAL_STORAGE_KEY", function () { return $bfeeaa29e3f9a245$export$5049c8654c52de2a; });
$parcel$export(module.exports, "sendConversionEventAlgolia", function () { return $bfeeaa29e3f9a245$export$b887d873139badc3; });
$parcel$export(module.exports, "handleAlgoliaConversionMetrics", function () { return $bfeeaa29e3f9a245$export$120e7b764d5fde54; });
$parcel$export(module.exports, "useA11yDropdownAnnouncement", function () { return $bfeeaa29e3f9a245$export$3d596a295dd7fc61; });
$parcel$export(module.exports, "HiddenAriaLiveAnnouncement", function () { return $bfeeaa29e3f9a245$export$e96bd116e2b4049a; });
/* auto-complete-helpers.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");

var $iSvIT = parcelRequire("iSvIT");

var $2bsWQ = parcelRequire("2bsWQ");

var $f6qj2 = parcelRequire("f6qj2");

var $gFK1O = parcelRequire("gFK1O");

var $1syhO = parcelRequire("1syhO");
const $bfeeaa29e3f9a245$export$17b978e8ab9e4c58 = "CU5KFWE75C";
const $bfeeaa29e3f9a245$export$ac6f6796ae1ab0c1 = "8cb0497a0549da256319b1b8178e5421";
const $bfeeaa29e3f9a245$export$b23c3af39ccf497d = "category";
const $bfeeaa29e3f9a245$export$74b39503c55b7612 = "www.atlassian.com.v2";
const $bfeeaa29e3f9a245$export$5b7165c5ebbdd78c = "www.atlassian.com.v2_dev";
const $bfeeaa29e3f9a245$export$9af986fa17e71039 = "www.atlassian.com.v3";
const $bfeeaa29e3f9a245$export$a7eaf02eb519d647 = "www.atlassian.com.v3_dev";
const $bfeeaa29e3f9a245$export$e9dac33bbaf86e02 = $bfeeaa29e3f9a245$export$74b39503c55b7612;
const $bfeeaa29e3f9a245$export$b337d69b7a65e111 = $bfeeaa29e3f9a245$export$9af986fa17e71039;
const $bfeeaa29e3f9a245$export$5049c8654c52de2a = "aa-autocomplete-pce";
async function $bfeeaa29e3f9a245$export$b887d873139badc3({ objectID: objectID, queryID: queryID }) {
    const algoliaApplicationID = $bfeeaa29e3f9a245$export$17b978e8ab9e4c58;
    const algoliaAdminAPIKey = $bfeeaa29e3f9a245$export$ac6f6796ae1ab0c1;
    const insightsURL = `https://insights.algolia.io/1/events`;
    const anonymousId = (0, $gFK1O.Cookie).readCookie("ajs_anonymous_id");
    let decodedAnonymousId;
    if (anonymousId) // the cookie value is URI encoded with quotes on the outside, so decode and remove them
    decodedAnonymousId = decodeURIComponent(anonymousId).replace(/['"]+/g, "");
    const eventData = {
        events: [
            {
                eventType: "conversion",
                eventName: "Result clicked (global nav)",
                index: $bfeeaa29e3f9a245$export$e9dac33bbaf86e02,
                userToken: decodedAnonymousId,
                objectIDs: [
                    objectID
                ],
                queryID: queryID
            }
        ]
    };
    try {
        const response = await (0, $2bsWQ.fetch)(insightsURL, {
            method: "POST",
            headers: {
                "X-Algolia-Application-Id": algoliaApplicationID,
                "X-Algolia-API-Key": algoliaAdminAPIKey,
                "Content-Type": "text/plain;charset=UTF-8"
            },
            body: JSON.stringify(eventData)
        });
        if (!response.ok) throw new Error(`Error: ${response.statusText}`);
    } catch (error) {
        console.error("Failed to send event:", error);
    }
}
const $bfeeaa29e3f9a245$var$removeConversionEventLocalStorageIfAlreadyExist = ()=>{
    if (localStorage.getItem($bfeeaa29e3f9a245$export$5049c8654c52de2a)) (0, $1syhO.removeLocalStorage)($bfeeaa29e3f9a245$export$5049c8654c52de2a);
};
const $bfeeaa29e3f9a245$var$setPotentialConversionEventLocalStorage = (stringifyConversionEventObject)=>{
    // reset localstorage if already exist
    $bfeeaa29e3f9a245$var$removeConversionEventLocalStorageIfAlreadyExist();
    (0, $1syhO.setLocalStorage)($bfeeaa29e3f9a245$export$5049c8654c52de2a, stringifyConversionEventObject, 3600 // per code comment, ttl in seconds for the localstorage. 3600 secs = 1hr
    );
};
const $bfeeaa29e3f9a245$export$120e7b764d5fde54 = (item)=>{
    if (item.url.includes("/signup")) {
        $bfeeaa29e3f9a245$var$removeConversionEventLocalStorageIfAlreadyExist();
        $bfeeaa29e3f9a245$export$b887d873139badc3({
            objectID: item.objectID,
            queryID: item.queryID,
            position: item.position
        });
    } else if (item.url.includes("/software/")) {
        const stringifyAttributes = JSON.stringify({
            objectID: item.objectID,
            queryID: item.queryID,
            position: item.position
        });
        $bfeeaa29e3f9a245$var$setPotentialConversionEventLocalStorage(stringifyAttributes);
    }
};
function $bfeeaa29e3f9a245$export$3d596a295dd7fc61(props) {
    const { resultsCount: resultsCount, searchTerm: searchTerm } = props;
    const [dropdownAnnouncement, setDropdownAnnouncement] = (0, $iSvIT.useState)("");
    (0, $iSvIT.useEffect)(()=>{
        setDropdownAnnouncement("");
    }, [
        searchTerm
    ]);
    const intl = (0, $f6qj2.default)();
    (0, $iSvIT.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setDropdownAnnouncement(intl.formatMessage({
                id: "AutoCompleteSearchBar.dropdown.announcement",
                defaultMessage: '{resultsCount} results displayed for search-term "{searchTerm}"'
            }, {
                resultsCount: resultsCount,
                searchTerm: searchTerm
            }));
        }, 2000);
        return ()=>clearTimeout(timer);
    }, [
        resultsCount,
        searchTerm
    ]);
    return {
        dropdownAnnouncement: dropdownAnnouncement
    };
}
const $bfeeaa29e3f9a245$export$e96bd116e2b4049a = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-live": "polite",
        className: (0, $esG4f.default)([
            "_kqswstnw _1bsbt94y _4t3it94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _ogtohxbz _1reo15vq _18m915vq"
        ]),
        children: props.children
    });
};

});

parcelRegister("3Bf61", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29f0898d81776aa2$var$_react = $29f0898d81776aa2$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $1IjLq = parcelRequire("1IjLq");
function $29f0898d81776aa2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $29f0898d81776aa2$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $29f0898d81776aa2$var$_react.default.createElement($1IjLq.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 010 1.414l-4.593 4.593a.99.99 0 01-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 011.4-1.4l4.593 4.593z"/></svg>`
    }, props));
$29f0898d81776aa2$var$ChevronRightLargeIcon.displayName = "ChevronRightLargeIcon";
var $29f0898d81776aa2$var$_default = $29f0898d81776aa2$var$ChevronRightLargeIcon;
module.exports.default = $29f0898d81776aa2$var$_default;

});

parcelRegister("d0cJX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9775286909ac5557$var$_react = $9775286909ac5557$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $1IjLq = parcelRequire("1IjLq");
function $9775286909ac5557$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9775286909ac5557$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $9775286909ac5557$var$_react.default.createElement($1IjLq.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M9.005 10.995l4.593-4.593a.99.99 0 111.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 01-1.4 1.4L9.005 12.41a1 1 0 010-1.414z"/></svg>`
    }, props));
$9775286909ac5557$var$ChevronLeftLargeIcon.displayName = "ChevronLeftLargeIcon";
var $9775286909ac5557$var$_default = $9775286909ac5557$var$ChevronLeftLargeIcon;
module.exports.default = $9775286909ac5557$var$_default;

});

parcelRegister("96J8a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a17ae9c03e0d534$var$_react = $6a17ae9c03e0d534$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $1IjLq = parcelRequire("1IjLq");
function $6a17ae9c03e0d534$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6a17ae9c03e0d534$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $6a17ae9c03e0d534$var$_react.default.createElement($1IjLq.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M4 5.01C4 4.451 4.443 4 5.01 4h1.98C7.549 4 8 4.443 8 5.01v1.98C8 7.549 7.557 8 6.99 8H5.01C4.451 8 4 7.557 4 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 13.549 7.557 14 6.99 14H5.01C4.451 14 4 13.557 4 12.99v-1.98zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C14 7.549 13.557 8 12.99 8h-1.98C10.451 8 10 7.557 10 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C20 7.549 19.557 8 18.99 8h-1.98C16.451 8 16 7.557 16 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 19.549 7.557 20 6.99 20H5.01C4.451 20 4 19.557 4 18.99v-1.98zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98z"/></svg>`
    }, props));
$6a17ae9c03e0d534$var$AppSwitcherIcon.displayName = "AppSwitcherIcon";
var $6a17ae9c03e0d534$var$_default = $6a17ae9c03e0d534$var$AppSwitcherIcon;
module.exports.default = $6a17ae9c03e0d534$var$_default;

});

parcelRegister("f448m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af7a6fa2fff8eb61$var$_react = $af7a6fa2fff8eb61$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $1IjLq = parcelRequire("1IjLq");
function $af7a6fa2fff8eb61$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $af7a6fa2fff8eb61$var$CrossIcon = (props)=>/*#__PURE__*/ $af7a6fa2fff8eb61$var$_react.default.createElement($1IjLq.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 10.586L6.707 5.293a1 1 0 00-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 001.414 1.414L12 13.414l5.293 5.293a1 1 0 001.414-1.414L13.414 12l5.293-5.293a1 1 0 10-1.414-1.414L12 10.586z" fill="currentColor"/></svg>`
    }, props));
$af7a6fa2fff8eb61$var$CrossIcon.displayName = "CrossIcon";
var $af7a6fa2fff8eb61$var$_default = $af7a6fa2fff8eb61$var$CrossIcon;
module.exports.default = $af7a6fa2fff8eb61$var$_default;

});

parcelRegister("5tcZn", function(module, exports) {

var $7Pwoh = parcelRequire("7Pwoh");

var $fkdjt = parcelRequire("fkdjt");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $3fb9bc86d9b07fbd$var$capitalize(string) {
    return $fkdjt($7Pwoh(string).toLowerCase());
}
module.exports = $3fb9bc86d9b07fbd$var$capitalize;

});
parcelRegister("fkdjt", function(module, exports) {

var $jKAgP = parcelRequire("jKAgP");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $b2830cfaaf0eef42$var$upperFirst = $jKAgP("toUpperCase");
module.exports = $b2830cfaaf0eef42$var$upperFirst;

});
parcelRegister("jKAgP", function(module, exports) {

var $ji61b = parcelRequire("ji61b");

var $fPcta = parcelRequire("fPcta");

var $ei0GC = parcelRequire("ei0GC");

var $7Pwoh = parcelRequire("7Pwoh");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $e60e72c04fe5b0cf$var$createCaseFirst(methodName) {
    return function(string) {
        string = $7Pwoh(string);
        var strSymbols = $fPcta(string) ? $ei0GC(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $ji61b(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $e60e72c04fe5b0cf$var$createCaseFirst;

});
parcelRegister("ji61b", function(module, exports) {

var $6Up2L = parcelRequire("6Up2L");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $e0b45dd3e501843f$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $6Up2L(array, start, end);
}
module.exports = $e0b45dd3e501843f$var$castSlice;

});
parcelRegister("6Up2L", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $507b662ca25b5d42$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $507b662ca25b5d42$var$baseSlice;

});


parcelRegister("fPcta", function(module, exports) {
/** Used to compose unicode character classes. */ var $b8554a9b43584300$var$rsAstralRange = "\ud800-\udfff", $b8554a9b43584300$var$rsComboMarksRange = "\\u0300-\\u036f", $b8554a9b43584300$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $b8554a9b43584300$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $b8554a9b43584300$var$rsComboRange = $b8554a9b43584300$var$rsComboMarksRange + $b8554a9b43584300$var$reComboHalfMarksRange + $b8554a9b43584300$var$rsComboSymbolsRange, $b8554a9b43584300$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $b8554a9b43584300$var$rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $b8554a9b43584300$var$reHasUnicode = RegExp("[" + $b8554a9b43584300$var$rsZWJ + $b8554a9b43584300$var$rsAstralRange + $b8554a9b43584300$var$rsComboRange + $b8554a9b43584300$var$rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $b8554a9b43584300$var$hasUnicode(string) {
    return $b8554a9b43584300$var$reHasUnicode.test(string);
}
module.exports = $b8554a9b43584300$var$hasUnicode;

});

parcelRegister("ei0GC", function(module, exports) {

var $1feF0 = parcelRequire("1feF0");

var $fPcta = parcelRequire("fPcta");

var $jlkJG = parcelRequire("jlkJG");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $a673476afac12397$var$stringToArray(string) {
    return $fPcta(string) ? $jlkJG(string) : $1feF0(string);
}
module.exports = $a673476afac12397$var$stringToArray;

});
parcelRegister("1feF0", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $0e82906dc4075dba$var$asciiToArray(string) {
    return string.split("");
}
module.exports = $0e82906dc4075dba$var$asciiToArray;

});

parcelRegister("jlkJG", function(module, exports) {
/** Used to compose unicode character classes. */ var $e150102b5bcf98b0$var$rsAstralRange = "\ud800-\udfff", $e150102b5bcf98b0$var$rsComboMarksRange = "\\u0300-\\u036f", $e150102b5bcf98b0$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $e150102b5bcf98b0$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $e150102b5bcf98b0$var$rsComboRange = $e150102b5bcf98b0$var$rsComboMarksRange + $e150102b5bcf98b0$var$reComboHalfMarksRange + $e150102b5bcf98b0$var$rsComboSymbolsRange, $e150102b5bcf98b0$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $e150102b5bcf98b0$var$rsAstral = "[" + $e150102b5bcf98b0$var$rsAstralRange + "]", $e150102b5bcf98b0$var$rsCombo = "[" + $e150102b5bcf98b0$var$rsComboRange + "]", $e150102b5bcf98b0$var$rsFitz = "\ud83c[\udffb-\udfff]", $e150102b5bcf98b0$var$rsModifier = "(?:" + $e150102b5bcf98b0$var$rsCombo + "|" + $e150102b5bcf98b0$var$rsFitz + ")", $e150102b5bcf98b0$var$rsNonAstral = "[^" + $e150102b5bcf98b0$var$rsAstralRange + "]", $e150102b5bcf98b0$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $e150102b5bcf98b0$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $e150102b5bcf98b0$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $e150102b5bcf98b0$var$reOptMod = $e150102b5bcf98b0$var$rsModifier + "?", $e150102b5bcf98b0$var$rsOptVar = "[" + $e150102b5bcf98b0$var$rsVarRange + "]?", $e150102b5bcf98b0$var$rsOptJoin = "(?:" + $e150102b5bcf98b0$var$rsZWJ + "(?:" + [
    $e150102b5bcf98b0$var$rsNonAstral,
    $e150102b5bcf98b0$var$rsRegional,
    $e150102b5bcf98b0$var$rsSurrPair
].join("|") + ")" + $e150102b5bcf98b0$var$rsOptVar + $e150102b5bcf98b0$var$reOptMod + ")*", $e150102b5bcf98b0$var$rsSeq = $e150102b5bcf98b0$var$rsOptVar + $e150102b5bcf98b0$var$reOptMod + $e150102b5bcf98b0$var$rsOptJoin, $e150102b5bcf98b0$var$rsSymbol = "(?:" + [
    $e150102b5bcf98b0$var$rsNonAstral + $e150102b5bcf98b0$var$rsCombo + "?",
    $e150102b5bcf98b0$var$rsCombo,
    $e150102b5bcf98b0$var$rsRegional,
    $e150102b5bcf98b0$var$rsSurrPair,
    $e150102b5bcf98b0$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $e150102b5bcf98b0$var$reUnicode = RegExp($e150102b5bcf98b0$var$rsFitz + "(?=" + $e150102b5bcf98b0$var$rsFitz + ")|" + $e150102b5bcf98b0$var$rsSymbol + $e150102b5bcf98b0$var$rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $e150102b5bcf98b0$var$unicodeToArray(string) {
    return string.match($e150102b5bcf98b0$var$reUnicode) || [];
}
module.exports = $e150102b5bcf98b0$var$unicodeToArray;

});





parcelRegister("9HFEq", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return (parcelRequire("dbhgV")).Card; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("dbhgV")).Card; });

var $dbhgV = parcelRequire("dbhgV");

});
parcelRegister("dbhgV", function(module, exports) {

$parcel$export(module.exports, "Card", function () { return $1d73d5771cc6d344$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");
const $1d73d5771cc6d344$var$containerStyles = null;
const $1d73d5771cc6d344$var$contentBlockStyles = null;
const $1d73d5771cc6d344$var$barStyles = null;
const $1d73d5771cc6d344$export$60332b2344f7fe41 = (props)=>{
    const { textColor: textColor, headerType: headerType, headerText: headerText, bodyText: bodyText, eyebrowText: eyebrowText, footerHeader: footerHeader, footerText: footerText, imageLink: imageLink, imageAltText: imageAltText, backgroundColor: backgroundColor, colorBars: colorBars, iconName: iconName, iconColor: iconColor, iconSize: iconSize, barColor: barColor = "", className: className, ctaProps: ctaProps, aspectRatio: aspectRatio, orientation: orientation, pictureProps: pictureProps, clickableCardUrl: clickableCardUrl } = props;
    if (imageLink && !imageAltText) throw new Error("If using an image, please provide an alt text for accessibility purposes!");
    const cardBackBackgroundColor = backgroundColor ?? "#ffffff";
    const cardBackTextColor = textColor ?? "#091e42";
    const cardBackColor = null;
    const contentBlockIconColor = iconColor ?? "#091e42";
    const handleClick = ()=>{
        if (clickableCardUrl) window.location.href = clickableCardUrl;
    };
    const clickableCardStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_2rkoyh40 _16qs1nta _1e0c1txw _2lx21bp4 _p12fg505 _7cca15wb _4t3i1osq",
            "_bfhk16d1 _syazn54i",
            "_80om1wzl",
            className
        ]),
        onClick: handleClick,
        style: {
            "--_1vkwvj7": (0, $43MIc.default)(cardBackBackgroundColor),
            "--_1dl5pj2": (0, $43MIc.default)(cardBackTextColor),
            "--_8vvi5m": (0, $43MIc.default)(clickableCardUrl ? "pointer" : "default")
        },
        children: [
            colorBars == "top" || colorBars == "both" ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderTopRightRadius: "4px",
                    borderTopLeftRadius: "4px"
                },
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : "",
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                cardStyle: true,
                aspectRatio: aspectRatio,
                orientation: orientation,
                headerType: headerType,
                headerText: headerText,
                bodyText: bodyText,
                imageLink: imageLink,
                imageAltText: imageAltText,
                eyebrowText: eyebrowText,
                footerHeader: footerHeader,
                footerText: footerText,
                iconColor: contentBlockIconColor,
                iconName: iconName,
                iconSize: iconSize,
                ctaProps: ctaProps,
                pictureProps: pictureProps,
                className: (0, $esG4f.default)([
                    "_4t3i1osq"
                ])
            }),
            colorBars == "bottom" || colorBars == "both" ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderBottomRightRadius: "4px",
                    borderBottomLeftRadius: "4px"
                },
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : ""
        ]
    });
};

});


parcelRegister("ieXtC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d477aba94fe327ce$var$_react = $d477aba94fe327ce$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $1IjLq = parcelRequire("1IjLq");
function $d477aba94fe327ce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d477aba94fe327ce$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $d477aba94fe327ce$var$_react.default.createElement($1IjLq.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><circle fill="inherit" cx="12" cy="18" r="1"/><path d="M15.89 9.05a3.975 3.975 0 00-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.992.992 0 00.982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 014.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 00-1 .987v2.014a1.001 1.001 0 002.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0015.89 9.05" fill="inherit"/></g></svg>`
    }, props));
$d477aba94fe327ce$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $d477aba94fe327ce$var$_default = $d477aba94fe327ce$var$QuestionCircleIcon;
module.exports.default = $d477aba94fe327ce$var$_default;

});

parcelRegister("isSvf", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return (parcelRequire("lxS8L")).Video; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("lxS8L")).Video; });

var $lxS8L = parcelRequire("lxS8L");

});
parcelRegister("lxS8L", function(module, exports) {

$parcel$export(module.exports, "Video", function () { return $ed253e67f972fd3a$export$ae01dedf5c052bb; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $ed253e67f972fd3a$var$videoStyle = (ratio)=>{
    const aspectRatioCSS = ratio && ratio !== "none" ? {
        aspectRatio: ratio,
        objectFit: "cover"
    } : {};
    return {
        maxWidth: "100%",
        ...aspectRatioCSS
    };
};
const $ed253e67f972fd3a$export$ae01dedf5c052bb = ({ videoLink: videoLink, videoType: videoType, videoPreviewImage: videoPreviewImage, loop: loop = true, muted: muted = true, aspectRatio: aspectRatio, alternativeSources: alternativeSources, className: className, fallbackText: fallbackText, onEnded: onEnded, children: children })=>{
    const videoRef = (0, $iSvIT.useRef)(null);
    // reload video player if video source prop changes dynamically
    (0, $iSvIT.useEffect)(()=>{
        videoRef.current?.load();
    }, [
        videoLink
    ]);
    return(// eslint-disable-next-line jsx-a11y/media-has-caption
    /*#__PURE__*/ (0, $loA2J.jsxs)("video", {
        playsInline: true,
        muted: muted,
        preload: "auto",
        poster: videoPreviewImage,
        autoPlay: true,
        className: className,
        style: $ed253e67f972fd3a$var$videoStyle(aspectRatio),
        loop: loop,
        ref: videoRef,
        onEnded: onEnded,
        children: [
            fallbackText,
            /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                src: videoLink,
                type: `video/${videoType ? videoType : "mp4"}`
            }),
            alternativeSources ? alternativeSources.map((source, index)=>{
                return /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    src: source.videoLink,
                    type: `video/${source.videoType ? source.videoType : "mp4"}`
                }, index);
            }) : null,
            children
        ]
    }));
};

});


parcelRegister("8A4p1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $63f519c8ab72f6bb$var$_react = $63f519c8ab72f6bb$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $1IjLq = parcelRequire("1IjLq");
function $63f519c8ab72f6bb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $63f519c8ab72f6bb$var$FeedbackIcon = (props)=>/*#__PURE__*/ $63f519c8ab72f6bb$var$_react.default.createElement($1IjLq.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M10.881 5.48l-8.426 6.829c-.396.32-.582.956-.413 1.417l.099.272c.168.462.726.829 1.227.82l1.131-.02 6.062-.102 3.652-.063c.51-.01.788-.385.616-.861l-2.923-8.03c-.105-.288-.324-.441-.567-.441a.731.731 0 00-.458.179zM4.98 15.953l1.754 4.818a1 1 0 101.879-.684l-1.539-4.228-2.094.094zm13.711-9.111l-2.819 1.026a1 1 0 10.684 1.879l2.82-1.026a1 1 0 10-.685-1.88zm-1.792 3.845a1.006 1.006 0 00-.644.766 1.002 1.002 0 00.811 1.159l2.955.52a1 1 0 001.122-1.301l-.017-.047a.997.997 0 00-.758-.621l-2.955-.521a.974.974 0 00-.514.045zm-.548-7.639l-1.929 2.298a1 1 0 001.532 1.286l1.928-2.298a1.001 1.001 0 00-.765-1.643.993.993 0 00-.766.357z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$63f519c8ab72f6bb$var$FeedbackIcon.displayName = "FeedbackIcon";
var $63f519c8ab72f6bb$var$_default = $63f519c8ab72f6bb$var$FeedbackIcon;
module.exports.default = $63f519c8ab72f6bb$var$_default;

});

parcelRegister("ixaDK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d7e38ffb7694e997$var$_react = $d7e38ffb7694e997$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $1IjLq = parcelRequire("1IjLq");
function $d7e38ffb7694e997$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d7e38ffb7694e997$var$RefreshIcon = (props)=>/*#__PURE__*/ $d7e38ffb7694e997$var$_react.default.createElement($1IjLq.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M8 6.003v2.995a1 1 0 102 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 000 2.003h3z" fill-rule="nonzero"/><path d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.979.979 0 00-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388z" fill-rule="nonzero"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 000-2.003h-3v-2.995a1 1 0 10-2 0z"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 00-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.957.957 0 0015.002 4a1 1 0 00-.905.596z"/></g></svg>`
    }, props));
$d7e38ffb7694e997$var$RefreshIcon.displayName = "RefreshIcon";
var $d7e38ffb7694e997$var$_default = $d7e38ffb7694e997$var$RefreshIcon;
module.exports.default = $d7e38ffb7694e997$var$_default;

});

parcelRegister("aOabo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7de678fbce1024bb$var$_react = $7de678fbce1024bb$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $1IjLq = parcelRequire("1IjLq");
function $7de678fbce1024bb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7de678fbce1024bb$var$RoadmapIcon = (props)=>/*#__PURE__*/ $7de678fbce1024bb$var$_react.default.createElement($1IjLq.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6 2h10a3 3 0 010 6H6a3 3 0 110-6zm0 2a1 1 0 100 2h10a1 1 0 000-2H6zm4 5h8a3 3 0 010 6h-8a3 3 0 010-6zm0 2a1 1 0 000 2h8a1 1 0 000-2h-8zm-4 5h6a3 3 0 010 6H6a3 3 0 010-6zm0 2a1 1 0 000 2h6a1 1 0 000-2H6z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$7de678fbce1024bb$var$RoadmapIcon.displayName = "RoadmapIcon";
var $7de678fbce1024bb$var$_default = $7de678fbce1024bb$var$RoadmapIcon;
module.exports.default = $7de678fbce1024bb$var$_default;

});

parcelRegister("3jjVc", function(module, exports) {

var $GDW72 = parcelRequire("GDW72");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $269299758f3ab5b3$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $GDW72(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $269299758f3ab5b3$var$get;

});
parcelRegister("GDW72", function(module, exports) {

var $aDJNh = parcelRequire("aDJNh");

var $258Tb = parcelRequire("258Tb");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $0802e6e01dab324b$var$baseGet(object, path) {
    path = $aDJNh(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$258Tb(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $0802e6e01dab324b$var$baseGet;

});



var $7Tq4R = parcelRequire("7Tq4R");

var $auFti = parcelRequire("auFti");
(0, $7Tq4R.init)((0, $auFti.JiraSoftwarePage));


//# sourceMappingURL=jira-software-page.c587510d.js.map
